webpackJsonp([1],{

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(314);

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__(153);

var _axios2 = _interopRequireDefault(_axios);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _elementUi = __webpack_require__(154);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var myAxios = _axios2.default.create({
  responseType: 'json',
  headers: { "content-type": "application/json" }
});


var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
  var len = len - (s + '').length;
  for (var i = 0; i < len; i++) {
    s = '0' + s;
  }
  return s;
};

exports.default = {
  QID: "",
  allowed: false,

  pagewidth: 0,
  axios: myAxios,
  header: [],
  payload: [],
  codes: [],

  getAuthMode: function getAuthMode(ulevel, target) {
    return [ulevel >= 5, ulevel >= 4, ulevel >= 4];
  },

  Initialize: function Initialize(router, qid) {
    this.QID = qid;
    this.allowed = this.IsAllowed(router, this.QID);
    if (!this.allowed) this.Forward(router, "XLI", null);
    return qid;
  },

  processMainResults: function processMainResults(result) {
    var d = result.data;
    if (typeof d === "string") d = JSON.parse(result.data);

    if (d.header) this.header = d.header;else this.header = [];

    if (d.payload) this.payload = d.payload;else this.payload = [];

    if (d.codes) this.codes = d.codes;else this.codes = [];
  },

  getMainCode: function getMainCode(codename) {
    if (this.codes[codename] != 'undefined') return this.codes[codename];else return {};
  },

  getMainPayload: function getMainPayload(item) {
    if (this.payload) {
      if (this.payload[item] != 'undefined') return this.payload[item];else return this.payload;
    } else return {};
  },

  getSubPayload: function getSubPayload(result, item) {
    var subpayload = [];
    if (result.data.payload) subpayload = result.data.payload;

    if (subpayload[item] != 'undefined') return subpayload[item];else return [];
  },

  getMainHeader: function getMainHeader(name) {
    if (this.header[name] != 'undefined') return this.header[name];else return "";
  },

  getSubHeader: function getSubHeader(result, name) {
    var subheader = {};
    if (result.data.header != 'undefined') subheader = result.data.header;

    if (subheader[name] != 'undefined') return subheader[name];else return "";
  },

  cloneParam: function cloneParam(input) {
    var cloned = JSON.parse((0, _stringify2.default)(input));
    return cloned;
  },

  getQueryStringByName: function getQueryStringByName(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    var context = "";
    if (r != null) context = r[2];
    reg = null;
    r = null;
    return context == null || context == "" || context == "undefined" ? "" : context;
  },

  saveLocal: function saveLocal(code, value) {
    if (typeof window.localStorage !== "undefined") return window.localStorage.setItem(code, value);else if (typeof window.sessionStorage !== "undefined") return window.sessionStorage.setItem(code, value);
  },

  getLocal: function getLocal(code) {
    if (typeof window.localStorage !== "undefined") return window.localStorage.getItem(code);else if (typeof window.sessionStorage !== "undefined") return window.sessionStorage.getItem(code);else return "";
  },

  arrayToArg: function arrayToArg(array_in) {
    if (array_in == null) return "";
    var out = new Array();
    for (var key in array_in) {
      out.push(key + '=' + array_in[key]);
    }
    return out.join('&');
  },

  getStageUrl: function getStageUrl(url) {
    var stage = window.stage;
    url = url.replace("{stage}", stage);
    return url;
  },

  callServerGet: function callServerGet(servermode, mainpage, array_in) {
    var cmd = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'list';

    var bearer = "Bearer " + window.sessionStorage.getItem('token');
    array_in["Module"] = mainpage;
    array_in["Action"] = cmd;
    array_in["WebStage"] = window.stage;
    array_in["Token"] = window.sessionStorage.getItem('token');
    var parlist = this.arrayToArg(array_in);
    return myAxios.get(this.getStageUrl(window.apiserver[servermode]), { headers: { 'Authorization': bearer } });
  },

  callServerPost: function callServerPost(servermode, mainpage, array_in) {
    var cmd = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'save';

    var bearer = "Bearer " + window.sessionStorage.getItem('token');
    array_in["Module"] = mainpage;
    array_in["Action"] = cmd;
    array_in["WebStage"] = window.stage;
    array_in["Token"] = window.sessionStorage.getItem('token');

    return myAxios.post(this.getStageUrl(window.apiserver[servermode]), array_in, { headers: { 'Authorization': bearer } });
  },


  callServerPut: function callServerPut(servermode, mainpage, array_in) {
    var cmd = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'add';

    var bearer = "Bearer " + window.Bearer;
    array_in["Module"] = mainpage;
    array_in["Action"] = cmd;
    array_in["WebStage"] = window.stage;
    array_in["Token"] = window.sessionStorage.getItem('token');
    return myAxios.put(this.getStageUrl(window.apiserver[servermode]), array_in, { headers: { 'Authorization': bearer } });
  },

  callServerDelete: function callServerDelete(servermode, mainpage, array_in) {
    var cmd = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "del";

    var bearer = "Bearer " + window.Bearer;
    array_in["Module"] = mainpage;
    array_in["Action"] = cmd;
    array_in["WebStage"] = window.stage;
    array_in["Token"] = window.sessionStorage.getItem('token');
    return myAxios.delete(this.getStageUrl(window.apiserver[servermode]), array_in, { headers: { 'Authorization': bearer } });
  },

  callServer: function callServer(servermode, mainpage, params) {
    return this.callServerPost(servermode, mainpage, params, false);
  },

  serverError: function serverError(parent) {
    parent.$message({
      title: "System Error", type: 'error',
      duration: 500,
      dangerouslyUseHTMLString: true,
      message: "<div style='line-height:30px;margin:20px;xtop:50px;font-size:20px'>The server seems to be down or not responding." + "<br>Try again later and contact admin when problem persists!</div>"
    });

    parent.listLoading = false;
  },


  message: function message(type, msg) {
    _elementUi.MessageBox.confirm(msg, type, {
      confirmButtonText: "OK",
      type: "warning"
    });
  },

  formatMoney: function formatMoney(value) {
    var formatter = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    });
    return formatter.format(value);
  },

  formatDate: {

    format: function format(date, pattern) {
      pattern = pattern || DEFAULT_PATTERN;
      return pattern.replace(SIGN_REGEXP, function ($0) {
        switch ($0.charAt(0)) {
          case 'y':
            return padding(date.getFullYear(), $0.length);
          case 'M':
            return padding(date.getMonth() + 1, $0.length);
          case 'd':
            return padding(date.getDate(), $0.length);
          case 'w':
            return date.getDay() + 1;
          case 'h':
            return padding(date.getHours(), $0.length);
          case 'm':
            return padding(date.getMinutes(), $0.length);
          case 's':
            return padding(date.getSeconds(), $0.length);
        }
      });
    },
    parse: function parse(dateString, pattern) {
      var matchs1 = pattern.match(SIGN_REGEXP);
      var matchs2 = dateString.match(/(\d)+/g);
      if (matchs1.length == matchs2.length) {
        var _date = new Date(1970, 0, 1);
        for (var i = 0; i < matchs1.length; i++) {
          var _int = parseInt(matchs2[i]);
          var sign = matchs1[i];
          switch (sign.charAt(0)) {
            case 'y':
              _date.setFullYear(_int);break;
            case 'M':
              _date.setMonth(_int - 1);break;
            case 'd':
              _date.setDate(_int);break;
            case 'h':
              _date.setHours(_int);break;
            case 'm':
              _date.setMinutes(_int);break;
            case 's':
              _date.setSeconds(_int);break;
          }
        }
        return _date;
      }
      return null;
    }

  },

  Forward: function Forward(router, id, parg) {
    var i = 0;
    var j = 0;
    var fto = "";
    for (i = 0; i < router.options.routes.length; i++) {
      if (router.options.routes[i].qid == id) {
        fto = router.options.routes[i].name;
        break;
      }
      if (router.options.routes[i].children) {
        for (j = 0; j < router.options.routes[i].children.length; j++) {
          if (router.options.routes[i].children[j].qid == id) {
            fto = router.options.routes[i].children[j].name;
            break;
          }
        }
      }
    }
    if (fto != "") {
      if (window.apidebug == 1) console.log("* " + id + " -> " + fto);
      router.push({ name: fto, params: parg });
    }
  },

  IsAllowed: function IsAllowed(router, id) {
    var i = 0;
    var j = 0;
    var roles = this.user("roles");
    var depts = this.user("depts");

    if (roles == "#S#" || id == "*") this.allowed = true;else if (roles == null) {
      console.log("Util.IsAllowed: NO user roles can be found!!!");
      this.allowed = false;
    } else {
      for (i = 0; i < router.options.routes.length; i++) {
        if (router.options.routes[i].qid == id) {
          this.allowed = roles.includes(router.options.routes[i].role);

          break;
        }
        if (router.options.routes[i].children) {
          for (j = 0; j < router.options.routes[i].children.length; j++) {
            if (router.options.routes[i].children[j].qid == id) {
              this.allowed = roles.includes(router.options.routes[i].children[j].role);
              this.allowed = this.allowed && depts.includes(router.options.routes[i].children[j].dept);
              break;
            }
          }
        }
      }
    }


    return this.allowed;
  },

  LoginMode: function LoginMode() {
    return server.ApiLoginMode;
  },

  GetAppPageWidth: function GetAppPageWidth() {
    var sidemenu = document.getElementById("sidemenu");
    var adj = 0;


    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) - adj;
  },

  GetThumb: function GetThumb(filename, thumb) {
    if (thumb != "" && thumb != null && thumb != 'undefined') {
      var p = filename.lastIndexOf('/');
      if (p > 0) return window.mediaserver + filename.substr(0, p + 1) + thumb;
    }
    return "";
  },

  showDate: function showDate(date) {
    if (date == null) return "";else return date.split('T')[0];
  },

  user: function user(type) {
    if (type == 'code') return sessionStorage.getItem('login');else if (type == 'login') return sessionStorage.getItem('login');else if (type == 'name') return sessionStorage.getItem('name');else if (type == 'level') return sessionStorage.getItem('userLevel');else if (type == 'avatar') return sessionStorage.getItem('avatar');else if (type == 'roles') return sessionStorage.getItem('roles');else if (type == 'depts') return sessionStorage.getItem('depts');
  },

  canUse: function canUse(funcRoles, funcDepts, userRoles, userDepts) {

    var ok = funcRoles == "" || userRoles == "super" || userRoles == "#S#";
    if (!ok) {
      var list = userRoles.split(' ');
      for (var i = 0; i < list.length; i++) {
        if (funcRoles.includes(list[i])) ok = true;
      }
    }

    if (ok) {
      ok = funcDepts == "" || userRoles == "super" || userRoles == "#S#";
      if (!ok) {
        var _list = userDepts.split(' ');
        for (var _i = 0; _i < _list.length; _i++) {
          if (funcDepts.includes(_list[_i])) ok = true;
        }
      }
    }

    return ok;
  },

  setSessionValue: function setSessionValue(code, value) {
    window.sessionStorage.setItem(code, value);
  },
  getSessionValue: function getSessionValue(code) {
    return window.sessionStorage.getItem(code);
  }

};

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var storage = {};

exports.default = {
  data: {
    yesno: "Yes,No",
    conf: "Confirmed",
    done: "Succes",
    mandatory: "This field is mandatory.",
    total: "Total",
    butSearch: "Search",
    butAdd: "Add",
    butSave: "Save",
    butCancel: "Cancel",
    butReturn: "Return",
    searchHolder: "Searching for...",

    sdelM: "Are you sure to delete {1} '{2}' ?",
    sdelT: "Delete {1}",

    addM: "Add {1}",
    modM: "Modify {1} : '{2}'",

    addOK: "{1} with code '{2}' is added.",
    modOK: "{1} with code '{2}' is modified.",
    delOK: "{1} with code '{2}' is deleted."
  },

  getText: function getText(id, var1, var2, var3) {
    var txt = this.data[id];
    return txt.replace("{1}", var1).replace("{2}", var2).replace("{3}", var3);
  }

};

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 1;
var ApiCode = "BasDossier";

exports.default = {

  execute: function execute(action, params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, action);
  },

  importDossier: function importDossier(params) {
    return _AppUtil2.default.callServerPost(ServerMode, "BasDossierImport", params, "import");
  },

  getListPage: function getListPage(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "list");
  },

  removeRecord: function removeRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "del");
  },

  addRecord: function addRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "add");
  },

  saveRecord: function saveRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "save");
  },

  getRecord: function getRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "get");
  },

  getPagedList: function getPagedList(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "pagedlist");
  }

};

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 1;
var ApiCode = "XStat";

exports.default = {
  getListPage: function getListPage(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "list");
  },
  getSanityPage: function getSanityPage(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "sanity");
  }
};

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 0;
var ApiCode = "login";

exports.default = {
  requestLogin: function requestLogin(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "login");
  },
  savePassword: function savePassword(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "save");
  },
  resetLogin: function resetLogin(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "reset");
  }
};

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 0;
var ApiCode = "XNews";

exports.default = {
  getNews: function getNews(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "shownews");
  },
  getHotNews: function getHotNews(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "hotnews");
  }

};

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(76);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _Login = __webpack_require__(608);

var _Login2 = _interopRequireDefault(_Login);

var _ChangePassword = __webpack_require__(606);

var _ChangePassword2 = _interopRequireDefault(_ChangePassword);

var _ = __webpack_require__(605);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(607);

var _Home2 = _interopRequireDefault(_Home);

var _Main = __webpack_require__(609);

var _Main2 = _interopRequireDefault(_Main);

var _maintenance = __webpack_require__(614);

var _maintenance2 = _interopRequireDefault(_maintenance);

var _xprofile = __webpack_require__(627);

var _xprofile2 = _interopRequireDefault(_xprofile);

var _xuser = __webpack_require__(629);

var _xuser2 = _interopRequireDefault(_xuser);

var _xdata = __webpack_require__(624);

var _xdata2 = _interopRequireDefault(_xdata);

var _xnews = __webpack_require__(626);

var _xnews2 = _interopRequireDefault(_xnews);

var _xshownews = __webpack_require__(628);

var _xshownews2 = _interopRequireDefault(_xshownews);

var _xcode = __webpack_require__(623);

var _xcode2 = _interopRequireDefault(_xcode);

var _xlog = __webpack_require__(625);

var _xlog2 = _interopRequireDefault(_xlog);

var _dbcload = __webpack_require__(622);

var _dbcload2 = _interopRequireDefault(_dbcload);

var _dbccheck = __webpack_require__(621);

var _dbccheck2 = _interopRequireDefault(_dbccheck);

var _site = __webpack_require__(616);

var _site2 = _interopRequireDefault(_site);

var _anvr = __webpack_require__(611);

var _anvr2 = _interopRequireDefault(_anvr);

var _supplier = __webpack_require__(617);

var _supplier2 = _interopRequireDefault(_supplier);

var _dossier = __webpack_require__(612);

var _dossier2 = _interopRequireDefault(_dossier);

var _dossierPaged = __webpack_require__(613);

var _dossierPaged2 = _interopRequireDefault(_dossierPaged);

var _Dossier_import = __webpack_require__(610);

var _Dossier_import2 = _interopRequireDefault(_Dossier_import);

var _view = __webpack_require__(618);

var _view2 = _interopRequireDefault(_view);

var _xstat = __webpack_require__(620);

var _xstat2 = _interopRequireDefault(_xstat);

var _xsanity = __webpack_require__(619);

var _xsanity2 = _interopRequireDefault(_xsanity);

var _report = __webpack_require__(615);

var _report2 = _interopRequireDefault(_report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{ path: '/login', component: _Login2.default, name: '', hidden: true, qid: 'XLI', dept: '', role: '' }, { path: '/changepassword', component: _ChangePassword2.default, name: '', hidden: true, qid: 'XWW', dept: '', role: '' }, { path: '/404', component: _2.default, name: '', hidden: true, qid: 'X404', dept: '', role: '' }, { path: '*', redirect: { path: '/404' }, hidden: true }, { path: '/',
  component: _Home2.default,
  redirect: '/main',
  name: 'BAS Services',
  iconCls: 'el-icon-s-order',
  dept: 'BAS FIN',
  role: '',
  children: [{ path: '/main', component: _Main2.default, name: 'Welcome', qid: "W", dept: 'BAS', role: '', hidden: true }, { path: '/dossier', component: _dossier2.default, name: 'Overview BAS Dossiers', qid: "DOS", dept: 'BAS FIN', role: '' }, { path: '/supplier', component: _supplier2.default, name: 'Maintain BAS Suppliers', qid: "SUP", dept: 'BAS', role: '' }, { path: '/site', component: _site2.default, name: 'Maintain BAS Sites', qid: "S", dept: 'BAS', role: 'admin' }, { path: '/anvr', component: _anvr2.default, name: 'Maintain ANVR codes', qid: "ANV", dept: 'BAS', role: '' }, { path: '/view', component: _view2.default, name: 'Define Report Views', qid: "RV", dept: 'BAS', role: 'admin' }, { path: '/reports', component: _report2.default, name: 'View BAS Reports', qid: "REP", dept: 'BAS FIN', role: '' }, { path: '/dossierImport', component: _Dossier_import2.default, name: 'Import Bas Dossier', qid: "IMP", dept: 'BAS', role: '', hidden: true }, { path: '/stat_BAS', component: _xstat2.default, name: 'Load BAS Statistics', qid: "STD", dept: 'BAS', role: '' }]
}, { path: '/',
  component: _Home2.default,
  name: 'Newskies - DBC',
  iconCls: 'el-icon-s-opportunity',
  dept: 'JDB',
  role: '',
  children: [{ path: '/dbcload', component: _dbcload2.default, name: 'View DBC Load stats', qid: "DBC", dept: 'JDB', role: '' }, { path: '/dbccheck', component: _dbccheck2.default, name: 'Online Booking Check', qid: "DBCC", dept: 'JDB', role: '' }]
}, { path: '/',
  component: _Home2.default,
  name: 'WRD Testing',
  iconCls: 'el-icon-s-flag',
  dept: 'BAS FIN',
  role: 'admin',
  children: [{ path: '/dossierPaged', component: _dossierPaged2.default, name: 'Browse BAS Dossiers', qid: "DOSX", dept: 'BAS FIN', role: 'admin' }]
}, { path: '/',
  component: _Home2.default,
  name: 'System Admin',
  iconCls: 'el-icon-s-tools',
  dept: '',
  role: 'lead admin super',
  children: [(0, _defineProperty3.default)({ path: '/sanity', component: _xsanity2.default, name: 'System Sanity Check', qid: "SC", dept: '', role: '' }, 'role', 'admin super'), { path: '/logs', component: _xlog2.default, name: 'Application Logs', qid: "XLG", dept: '', role: 'admin lead' }, { path: '/maint', component: _maintenance2.default, name: 'App Maintenance', qid: "MAINT", dept: 'WRD', role: 'admin' }, { path: '/xdata', component: _xdata2.default, name: 'Data Snippets', qid: "XD", dept: '', role: 'admin lead' }, { path: '/xnews', component: _xnews2.default, name: 'App News', qid: "XN", dept: '', role: 'admin lead' }, { path: '/xcodes', component: _xcode2.default, name: 'Generic Codes', qid: "XCD", dept: '', role: 'admin lead' }, { path: '/users', component: _xuser2.default, name: 'Users', qid: "XU", dept: '', role: 'admin super' }, { path: '/shownews', component: _xshownews2.default, name: 'Latest News', qid: "XL", dept: '', role: '', hidden: true }, { path: '/profile', component: _xprofile2.default, name: 'User Profile', hidden: true, qid: 'PRO', dept: '', role: '' }]
}];

exports.default = routes;

/***/ }),

/***/ 228:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(576)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(638),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'app',
  components: {}
};

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _login = __webpack_require__(166);

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      QID: util.Initialize(this.$router, "*"),
      passwordForm: {
        id: "",
        password: "",
        retype: ""
      },
      rules: {},
      checked: true
    };
  },

  methods: {
    isPasswordInValid: function isPasswordInValid(password) {
      return this.passwordForm.password.length < 8 || this.passwordForm.password != this.passwordForm.retype;
    },
    changeSubmit: function changeSubmit() {
      var _this = this;

      if (this.passwordForm.password != '') {
        var parg = this.stack;
        parg["password"] = this.passwordForm.password;

        _login2.default.savePassword(parg).then(function (response) {

          _this.$message({
            title: "Your password has been changed", type: 'success',
            duration: 8000,
            dangerouslyUseHTMLString: true,
            message: "<div style='font-height:16px;line-height:30px;margin:10px'>Your password has been saved and you are redirected to login. Please use your new login credentials.</div>"
          });
          _this.$router.push("login");
        });

        this.resetVisible = false;
      }
    }
  },
  mounted: function mounted() {
    this.apiserver = window.apiserver;


    if (this.$route.query) {
      this.stack = this.$route.query;
      this.passwordForm["id"] = this.stack.id;
    }
  }
};

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
		value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
		data: function data() {
				return {
						QID: _AppUtil2.default.Initialize(this.$router, "*"),
						showMiniMenu: false,

						sysName: 'EnergyWatch',
						appBuild: window.appbuild,
						collapsed: false,
						userLevel: 0,
						userRoles: 'sys',
						departments: '',
						userToken: '',
						stageClass: 'dev',
						stageSubtitle: '',
						sysUserName: '',
						sysUserAvatar: '',
						form: {}
				};
		},

		methods: {
				canUse: function canUse(item) {
						return _AppUtil2.default.canUse(item.role, item.dept, this.userRoles, this.departments);
				},
				onSubmit: function onSubmit() {},
				handleopen: function handleopen() {},
				handleclose: function handleclose() {},


				handleselect: function handleselect(a, b) {},

				openPage: function openPage(link) {
						this.$router.push(link);
				},

				versionInfo: function versionInfo() {
						if (window.apiserver == undefined) {
								return "Startup: " + 'EnergyWatch';
						} else {
								this.sysName = window.appname;
								this.stageClass = window.stage;

								if (window.stage != "prd") this.stageSubtitle = " [" + window.stage.substring(0, 1).toUpperCase() + "]";

								return "App name: " + window.appname + " (" + window.appbuild[0] + ")" + "\nVersion : " + window.appbuild[1] + "\nCreated : " + window.appbuild[2] + "\nMain API: " + _AppUtil2.default.getStageUrl(window.apiserver[0]);
						}
				},

				logout: function logout() {
						var _this = this;
						this.$confirm('Are you sure to leave this session ?', 'Logout', {
								cancelButtonText: "Eh, no",
								confirmButtonText: "Sure",
								type: "warning" }).then(function () {
								sessionStorage.setItem("force", "1");
								sessionStorage.removeItem('user');
								_this.$router.push('/login');
						}).catch(function () {});
				},

				collapse: function collapse() {
						this.collapsed = !this.collapsed;
				},

				showMenu: function showMenu(i, status) {
						this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
				}
		},

		mounted: function mounted() {
				if (window.innerWidth < 800) {
						this.collapsed = true;
				}
				this.userToken = sessionStorage.getItem('token');
				this.sysUserAvatar = sessionStorage.getItem('avatar');
				this.sysUserName = sessionStorage.getItem('name');
				this.sysLogin = sessionStorage.getItem('login');
				this.userLevel = sessionStorage.getItem("userLevel");
				this.userRoles = sessionStorage.getItem('roles');
				this.departments = sessionStorage.getItem('depts');
		}
};

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _login = __webpack_require__(166);

var _login2 = _interopRequireDefault(_login);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      QID: _AppUtil2.default.Initialize(this.$router, "*"),
      util: _AppUtil2.default,
      logining: false,
      loginMode: 1,
      stage: "",
      stageClass: "dev",
      resetVisible: false,
      loginVisible: true,
      resetForm: { email: "" },

      ruleForm2: {
        account: '',
        checkPass: ''
      },
      rules2: {
        account: [{ required: true, message: 'Your logincode is required', trigger: 'blur' }],
        checkPass: [{ required: true, message: 'Enter your password', trigger: 'blur' }]
      },
      checked: true
    };
  },

  methods: {
    isEmailInvalid: function isEmailInvalid(email) {
      var re = /\S+@\S+\.\S+/;
      return !re.test(email);
    },
    resetPassword: function resetPassword() {
      this.resetVisible = true;
    },
    resetSubmit: function resetSubmit() {
      var _this2 = this;

      if (this.resetForm.email != '') {
        var parg = [];
        parg["email"] = this.resetForm.email;
        _login2.default.resetLogin(parg).then(function (response) {

          _this2.resetVisible = false;
          _this2.$message({
            title: "Reset Request has been send", type: 'success',
            duration: 8000,
            dangerouslyUseHTMLString: true,
            message: "<div style='font-height:16px;line-height:30px;margin:10px'>If you are an active user on our system you will receive an email<br> with further instructions. Check your inbox (do not forget your spambox).</div>"
          });
        });

        this.resetVisible = false;
      }
    },


    setFocus: function setFocus() {
      if (this.loginMode < 2) this.$refs.account.focus();
    },

    handleSubmit2: function handleSubmit2(ev) {
      var _this3 = this;

      var _this = this;
      var _user = { Status: false };

      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          _this3.logining = true;
          var parg = {};
          parg.Params = {};
          parg.Module = "Login";
          parg.Action = "login";
          parg.Params.username = _this3.ruleForm2.account;
          parg.Params.password = _this3.ruleForm2.checkPass;

          _login2.default.requestLogin(parg).then(function (response) {

            _this3.logining = false;

            var userRequest = response.data;
            if (typeof userRequest === "string") userRequest = JSON.parse(response.data);

            if (userRequest.header.OK == true) _user = userRequest.payload.user;

            var isOK = _user.Status == "OK";
            if (isOK) {
              sessionStorage.setItem('token', _user.Token);
              sessionStorage.setItem('name', _user.Name);
              sessionStorage.setItem('avatar', "./static/" + _user.Avatar);
              sessionStorage.setItem('login', _user.Code);
              sessionStorage.setItem('roles', _user.Roles);
              sessionStorage.setItem('depts', _user.Departments);

              window.localStorage.setItem("selgroup", "");

              if (_user.pwdreset == 1) _this3.$router.push('/profile');else _this3.$router.push({ path: '/' });
            } else {

              sessionStorage.setItem('name', "");
              sessionStorage.setItem('avatar', "./static/users/p1.png");
              sessionStorage.setItem("userLevel", "0");
              sessionStorage.setItem('token', "");
              sessionStorage.setItem('roles', "");
              sessionStorage.setItem('depts', "");

              _this3.$message({
                message: userRequest.header.message,
                duration: 8000,
                type: 'error'
              });
              _this3.setFocus();
            }
          });
        } else {
          _this3.setFocus();
          return false;
        }
      });
    }
  },

  created: function created() {
    var _this4 = this;

    setTimeout(function (x) {
      _this4.$nextTick(function () {
        return _this4.setFocus();
      });
    }, 1000);
  },
  mounted: function mounted() {
    console.log("INIT LOGIN");

    if (window.sessionStorage.getItem("force") == 1) {
      window.sessionStorage.removeItem("force");
      this.loginMode = 1;
    }
    this.stage = window.stage == 'prd' ? "" : window.stage.toUpperCase();
  }
};

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _xshownews = __webpack_require__(167);

var _xshownews2 = _interopRequireDefault(_xshownews);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      QID: _AppUtil2.default.Initialize(this.$router, "*"),
      util: _AppUtil2.default,
      stack: {},
      lang: _AppText2.default.data,
      pageSize: _AppSettings2.default.pageSize,
      serverPaging: false,

      APICode: "XNews",
      content: [],
      counter: {},
      currentPage: 1,
      mainTotal: 0,
      userLevel: window.sessionStorage.getItem('userLevel'),

      listLoading: false
    };
  },


  methods: {
    bodystyle: function bodystyle(hot) {
      if (hot) return "background-color:#eaf3ff";else return "";
    },

    OpenMoreNews: function OpenMoreNews() {
      var arg = {};
      this.$router.push({ name: 'Latest News', arg: arg });
    },

    openLink: function openLink(link) {
      var arg = {};
      this.$router.push({ name: link, arg: arg });
    },

    selectPagesize: function selectPagesize(size) {
      _AppSettings2.default.pageSize = size;
      this.showPagedData();
    },
    selectPage: function selectPage(page) {
      this.currentPage = page;
      this.showPagedData();
    },
    showPagedData: function showPagedData() {
      if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
    },

    getRecords: function getRecords() {
      var _this = this;

      var parg = {};

      this.listLoading = true;

      _xshownews2.default.getHotNews(parg).then(function (res) {
        _AppUtil2.default.processMainResults(res);
        _this.codes = _AppUtil2.default.codes;
        _this.mainTotal = _AppUtil2.default.getMainPayload(_this.APICode).length;

        if (_this.mainTotal > 0) {
          if (_this.serverPaging) _this.content = _AppUtil2.default.getMainPayload(_this.APICode);else {
            _this.contentSaved = _AppUtil2.default.getMainPayload(_this.APICode);
            if (_this.contentSaved.length > 0) _this.selectPage(1);
          }
        } else {
          _this.content = [];
          _this.contentSaved = [];
        }
        _this.listLoading = false;
      });
    }
  },

  mounted: function mounted() {
    this.related = _AppSettings2.default.getRelated();
    this.getRecords();
  }
};

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _dossier = __webpack_require__(103);

var _dossier2 = _interopRequireDefault(_dossier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      QID: _AppUtil2.default.Initialize(this.$router, "DOS"),
      util: _AppUtil2.default,
      stack: {},
      lang: _AppText2.default.data,
      APICode: "BasDossierImport",
      mainFunc: "Dossier XML",
      mainSubject: "Dossier",
      mainKey: "dossierid",
      mainKeyDesc: "dossierid",
      sitecode: "",
      sites: [],

      data: [],
      session: {},
      content: [],
      counter: {},
      related: {},
      xmldata: "",
      xmlfile: "",
      listLoading: false,
      editForm: {},
      editFormVisible: false,
      editLoading: false,
      editMode: '',
      editTitle: '',

      editFormRules: {
        name: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
      }

    };
  },

  methods: {
    htmlData: function htmlData(val) {
      var ret = "" + val;
      return ret.replace(/\\/g, '');
    },
    getRecords: function getRecords() {
      this.listLoading = true;

      var parg = this.stack;
    },

    closeForm: function closeForm() {
      this.selectorVisible = false;
      var parg = this.stack;
      _AppUtil2.default.Forward(this.$router, "DOS", parg);
    },

    Upload: function Upload() {
      var _this = this;

      var parg = {};
      parg["Module"] = "BasDossierImport";
      parg["Action"] = "Import";
      parg["Content"] = this.xmldata;
      parg["Params"] = {};
      parg["Params"]["site"] = this.sitecode;

      _dossier2.default.importDossier(parg).then(function (res) {
        _AppUtil2.default.processMainResults(res);
        _this.editForm = _AppUtil2.default.getMainPayload(_this.APICode);
        _this.editFormVisible = true;
        _this.listLoading = false;
        _this.closeForm();
      });
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    window.addEventListener("popstate", function (event) {
      _this2.closeForm();
    });

    if (this.$route.params) {
      this.stack = this.$route.params;
      this.sites = this.stack.Params.sites;
      if (this.$route.site) this.sitecode = this.$route.site;else this.sitecode = this.sitecode = this.sites[0].code;
    }

    this.getRecords();
  }
};

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _anvr = __webpack_require__(298);

var _anvr2 = _interopRequireDefault(_anvr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			QID: _AppUtil2.default.Initialize(this.$router, "ANVR"),
			util: _AppUtil2.default,
			stack: {},
			stage: window.stage,
			lang: _AppText2.default.data,
			codes: _AppUtil2.default.codes,
			pageSize: _AppSettings2.default.pageSize,
			serverPaging: false,

			editTitle: "",
			editMode: "",
			userDepts: "",
			userRoles: "",
			APICode: "BasAnvr",
			mainFunc: "Anvr",
			mainSubject: "Anvr",
			mainKey: "anvrid",
			mainKeyDesc: "name",
			searchFilter: '',
			content: [],
			counter: {},
			related: [],
			currentPage: 1,
			mainTotal: 0,

			listLoading: false,
			editFormVisible: false,
			editLoading: false,
			editForm: {},
			editFormRules: {
				anvrid: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
			}

		};
	},


	methods: {
		closeForm: function closeForm() {
			this.selectorVisible = false;
			this.$router.push({ name: 'Employees', params: this.stack });
		},

		startSearch: function startSearch() {
			this.currentPage = 1;
			this.content = [];
			this.getRecords();
		},

		selectPagesize: function selectPagesize(size) {
			_AppSettings2.default.pageSize = size;
			this.showPagedData();
		},
		selectPage: function selectPage(page) {
			this.currentPage = page;
			this.showPagedData();
		},
		showPagedData: function showPagedData() {
			if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
		},

		getRecords: function getRecords() {
			var _this = this;

			var parg = {};
			parg.Params = {};
			parg.Params.search = this.searchFilter;

			this.listLoading = true;

			_anvr2.default.getListPage(parg).then(function (res) {
				_AppUtil2.default.processMainResults(res);
				_this.codes = _AppUtil2.default.codes;
				_this.mainTotal = _AppUtil2.default.payload[_this.APICode].length;

				if (_this.mainTotal > 0) {
					if (_this.serverPaging) _this.content = _AppUtil2.default.getMainPayload(_this.APICode);else {
						_this.contentSaved = _AppUtil2.default.getMainPayload(_this.APICode);
						if (_this.contentSaved.length > 0) _this.selectPage(1);
					}
				} else {
					_this.content = [];
					_this.contentSaved = [];
				}
				_this.listLoading = false;
			}).catch(function (error) {
				_AppUtil2.default.serverError(_this);
			});
		},


		openRelated: function openRelated(row) {},

		handleDel: function handleDel(row) {
			var _this2 = this;

			this.$confirm(_AppText2.default.getText("sdelM", this.mainSubject, row[this.mainKeyDesc]), 'Confirm', {
				type: 'warning', title: _AppText2.default.getText("sdelT", this.mainSubject)
			}).then(function () {
				_this2.listLoading = true;

				var parg = {};
				parg.Record = row;

				_anvr2.default.removeRecord(parg).then(function (res) {
					_this2.listLoading = false;
					_this2.$notify({
						title: _AppText2.default.data.conf, type: 'success',
						message: _AppText2.default.getText("delOK", _this2.mainSubject, row[_this2.mainKey])
					});
					_this2.getRecords();
				});
			}).catch(function () {});
		},

		handleEdit: function handleEdit(row) {
			this.editMode = "save";
			this.editTitle = _AppText2.default.getText("modM", this.mainSubject, row[this.mainKey]);
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.editMode = "add";
			this.editTitle = _AppText2.default.getText("addM", this.mainSubject);
			this.editFormVisible = true;
			this.editForm = {};
		},

		editSubmit: function editSubmit() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					_this3.editLoading = true;

					var parg = {};
					parg.Params = {};
					parg.Record = (0, _assign2.default)({}, _this3.editForm);

					if (_this3.editMode == "add") {
						parg.Action = "add";
						_anvr2.default.addRecord(parg).then(function (res) {
							if (res.data.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
								message: _AppText2.default.getText("addOK", _this3.mainSubject, _this3.editForm.name) });else _this3.$notify({ title: "Error", type: 'error', message: res.data.header.message });
							_this3.$refs['editForm'].resetFields();
							_this3.editLoading = false;
							_this3.editFormVisible = false;
							_this3.getRecords();
						});
					} else {
						parg.Action = "save";
						_anvr2.default.saveRecord(parg).then(function (res) {
							if (res.data.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
								message: _AppText2.default.getText("modOK", _this3.mainSubject, _this3.editForm.name) });else _this3.$notify({ title: "Error", type: 'error', message: res.data.header.message });
							_this3.$refs['editForm'].resetFields();
							_this3.editLoading = false;
							_this3.editFormVisible = false;
							_this3.getRecords();
						});
					}
				}
			});
		}

	},

	mounted: function mounted() {
		var _this4 = this;

		window.addEventListener("popstate", function (event) {
			_this4.closeForm();
		});

		this.userDepts = sessionStorage.getItem("depts");
		this.userRoles = sessionStorage.getItem("roles");

		if (this.$route.params) {
			this.stack = this.$route.params;
		}

		this.related = _AppSettings2.default.getRelated();
		this.getRecords();
	}
};

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__(76);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _dossier = __webpack_require__(103);

var _dossier2 = _interopRequireDefault(_dossier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var _ref;

    return _ref = {
      searchFields: ["Dossier", "Booker", "Destination", "Segment"],
      statusList: [{ cd: 0, va: "Open" }, { cd: 1, va: "Processing" }, { cd: 2, va: "Loaded" }, { cd: 3, va: "Pushed to Racs" }, { cd: 5, va: "Load Error" }, { cd: 6, va: "Push Error" }, { cd: 9, va: "SKIP this Dossier" }],
      QID: _AppUtil2.default.Initialize(this.$router, "Dossier"),
      util: _AppUtil2.default,
      stack: {},
      lang: _AppText2.default.data,
      codes: _AppUtil2.default.codes,
      pageSize: _AppSettings2.default.pageSize,
      serverPaging: false,
      periode: "1",
      periodeLast: "1",
      sitecode: "BC",
      stage: window.stage,

      currentTab: "T1",

      anonymize: true,
      numRecs: 250
    }, (0, _defineProperty3.default)(_ref, 'sitecode', ""), (0, _defineProperty3.default)(_ref, 'viewXmlVisible', false), (0, _defineProperty3.default)(_ref, 'viewDetailsVisible', false), (0, _defineProperty3.default)(_ref, 'outtypes', ["JSON", "XML"]), (0, _defineProperty3.default)(_ref, 'outtype', "JSON"), (0, _defineProperty3.default)(_ref, 'currentTab', "T1"), (0, _defineProperty3.default)(_ref, 'outdata', ""), (0, _defineProperty3.default)(_ref, 'dossier', ""), (0, _defineProperty3.default)(_ref, 'xmldata', ""), (0, _defineProperty3.default)(_ref, 'xmlfile', ""), (0, _defineProperty3.default)(_ref, 'editTitle', ""), (0, _defineProperty3.default)(_ref, 'editMode', ""), (0, _defineProperty3.default)(_ref, 'userDepts', ""), (0, _defineProperty3.default)(_ref, 'userRoles', ""), (0, _defineProperty3.default)(_ref, 'APICode', "BasDossier"), (0, _defineProperty3.default)(_ref, 'mainFunc', "Dossier"), (0, _defineProperty3.default)(_ref, 'mainSubject', "Dossier"), (0, _defineProperty3.default)(_ref, 'mainKey', "D"), (0, _defineProperty3.default)(_ref, 'mainKeyDesc', "D"), (0, _defineProperty3.default)(_ref, 'searchFilter', ''), (0, _defineProperty3.default)(_ref, 'content', []), (0, _defineProperty3.default)(_ref, 'counter', {}), (0, _defineProperty3.default)(_ref, 'related', []), (0, _defineProperty3.default)(_ref, 'currentPage', 1), (0, _defineProperty3.default)(_ref, 'mainTotal', 0), (0, _defineProperty3.default)(_ref, 'searchField', "Booker"), (0, _defineProperty3.default)(_ref, 'detailFin', ""), (0, _defineProperty3.default)(_ref, 'detailHist', ""), (0, _defineProperty3.default)(_ref, 'detailLocate', ""), (0, _defineProperty3.default)(_ref, 'detailFinLoaded', false), (0, _defineProperty3.default)(_ref, 'detailHistLoaded', false), (0, _defineProperty3.default)(_ref, 'detailLocateLoaded', false), (0, _defineProperty3.default)(_ref, 'detailTransport', ""), (0, _defineProperty3.default)(_ref, 'listLoading', false), (0, _defineProperty3.default)(_ref, 'editFormVisible', false), (0, _defineProperty3.default)(_ref, 'editLoading', false), (0, _defineProperty3.default)(_ref, 'editForm', {}), (0, _defineProperty3.default)(_ref, 'editFormRules', {
      siteid: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
    }), _ref;
  },


  methods: {

    closeForm: function closeForm() {
      this.selectorVisible = false;
      this.$router.push({ name: 'Employees', params: this.stack });
    },

    startSearch: function startSearch() {
      if (this.periode.startsWith(".")) {
        this.periode = this.periodeLast;
      } else {
        this.periodeLast = this.periode;
        this.currentPage = 1;
        this.content = [];
        this.getRecords();
      }
    },

    selectPagesize: function selectPagesize(size) {
      _AppSettings2.default.pageSize = size;
      this.showPagedData();
    },
    selectPage: function selectPage(page) {
      this.currentPage = page;
      this.showPagedData();
    },
    showPagedData: function showPagedData() {
      if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
    },

    getRecords: function getRecords() {
      var _this = this;

      var parg = {};
      parg.Params = {};
      parg.Params.site = this.sitecode;
      parg.Params.period = this.periode;
      parg.Params.search = this.searchFilter;
      parg.Params.field = this.searchField;
      parg.Params.currentPage = this.currentPage;

      parg.Params.pageNum = this.currentPage;

      _AppUtil2.default.setSessionValue("site", this.sitecode);
      _AppUtil2.default.setSessionValue("period", this.periode);

      this.listLoading = true;

      _dossier2.default.getListPage(parg).then(function (res) {
        _AppUtil2.default.processMainResults(res);
        _this.codes = _AppUtil2.default.codes;
        _this.mainTotal = _AppUtil2.default.header["totalRecs"];

        if (_this.sitecode == "" && _this.codes.sites[0]) _this.sitecode = _this.codes.sites[0].code;

        if (_this.mainTotal > 0) {
          if (_this.serverPaging) _this.content = _AppUtil2.default.getMainPayload(_this.APICode);else {
            _this.contentSaved = _AppUtil2.default.getMainPayload(_this.APICode);
            if (_this.contentSaved.length > 0) _this.selectPage(1);
          }
        } else {
          _this.content = [];
          _this.contentSaved = [];
        }
        _this.listLoading = false;
      }).catch(function (error) {
        _AppUtil2.default.serverError(_this);
      });
    },


    clickTab: function clickTab(tab, event) {
      if (this.currentTab == "FIN" && this.detailFinLoaded == false) this.openTabDetails("fin");else if (this.currentTab == "HIST" && this.detailHistLoaded == false) this.openTabDetails("hist");else if (this.currentTab == "LOCATE" && this.detailLocateLoaded == false) this.openTabDetails("locate");
    },

    openTabDetails: function openTabDetails(loadSet) {
      var _this2 = this;

      if (loadSet != "") {
        var parg = {};
        parg.Params = {};
        parg.Params.site = this.sitecode;
        parg.Params.period = this.periode;
        parg.Params.search = this.searchFilter;
        parg.Params.field = this.searchField;
        parg.Params.dosid = this.editForm['D'];
        parg.Params.currentPage = this.currentPage;
        parg.Params.loadset = loadSet;

        _dossier2.default.execute('findet', parg).then(function (res) {
          var d = res.data;
          if (typeof d === "string") d = JSON.parse(res.data);

          if (loadSet == 'fin') {
            _this2.detailFin = d.payload.findet;
            if (_this2.detailFin == "") _this2.detailFin = "- No details -";
            _this2.detailFinLoaded = true;
          } else if (loadSet == 'hist') {
            _this2.detailHist = d.payload.findet;
            _this2.detailHistLoaded = true;
          } else if (loadSet == 'locate') {
            _this2.detailLocate = d.payload.verblijf;
            _this2.detailTransport = d.payload.transport;
            if (_this2.detailLocate == "") _this2.detailLocate = "- No details -";
            if (_this2.detailTransport == "") _this2.detailTransport = "- No details -";
            _this2.detailLocateLoaded = true;
          }
        }).catch(function (error) {
          _AppUtil2.default.serverError(_this2);
        });
      }
    },


    openRelated: function openRelated(row) {},

    handleDel: function handleDel(row) {
      var _this3 = this;

      this.$confirm(_AppText2.default.getText("sdelM", this.mainSubject, row[this.mainKeyDesc]), 'Confirm', {
        type: 'warning', title: _AppText2.default.getText("sdelT", this.mainSubject)
      }).then(function () {
        _this3.listLoading = true;
        var parg = {};
        parg.Params = {};

        parg.Params['dosid'] = row.D;

        _dossier2.default.removeRecord(parg).then(function (res) {
          _this3.listLoading = false;
          _this3.$notify({
            title: _AppText2.default.data.conf, type: 'success',
            message: _AppText2.default.getText("delOK", _this3.mainSubject, row[_this3.mainKey])
          });
          _this3.getRecords();
        });
      }).catch(function () {});
    },

    handleEdit: function handleEdit(row) {
      this.editMode = "save";
      this.editTitle = "View BAS Dossier " + row[this.mainKey];
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)({}, row);
      this.detailFin = "";
      this.detailHist = "";
      this.detailLocate = "";
      this.detailFinLoaded = false;
      this.detailHistLoaded = false;
      this.detailLocateLoaded = false;
      this.currentTab = "T1";
    },

    handleView: function handleView(row) {
      this.getDetailData(row.D);
    },

    reloadData: function reloadData() {
      this.getDetailData(this.dossier);
    },

    getDetailData: function getDetailData(dosid) {
      var _this4 = this;

      var parg = {};
      parg.Params = {};
      parg.Params.site = this.sitecode;
      parg.Params.dosid = dosid;
      this.dossier = dosid;
      parg.Params.period = this.periode;
      parg.Params.search = this.searchFilter;
      parg.Params.field = this.searchField;
      parg.Params.currentPage = this.currentPage;

      parg.Params["type"] = this.outtype;

      _dossier2.default.execute("detail", parg).then(function (res) {
        var d = res.data;
        if (typeof d === "string") d = JSON.parse(res.data);
        _this4.outdata = d.payload.outdata;
        _this4.viewDetailsVisible = true;
        _this4.listLoading = false;
      });
    },

    handleXml: function handleXml(row, mode) {
      var _this5 = this;

      var parg = {};
      parg.Params = {};
      parg.Params.site = this.sitecode;
      parg.Params.dosid = row.D;
      parg.Params.period = this.periode;
      parg.Params.search = this.searchFilter;
      parg.Params.field = this.searchField;
      parg.Params.currentPage = this.currentPage;

      parg.Params = {};
      parg.Params.site = this.sitecode;
      parg.Params.dosid = row.D;
      parg.Params.period = this.periode;
      parg.Params.search = this.searchFilter;
      parg.Params.field = this.searchField;
      parg.Params.currentPage = this.currentPage;
      parg.Params.mode = mode;

      this.listLoading = true;

      _dossier2.default.execute("xml", parg).then(function (res) {
        var d = res.data;
        if (typeof d === "string") d = JSON.parse(res.data);

        _this5.xmldata = d.payload.xml;
        _this5.xmlfile = d.payload.xmlfile;
        _this5.dossier = parg.Params.dosid;
        _this5.viewXmlVisible = true;
        _this5.listLoading = false;
      });
    },

    handleImport: function handleImport() {
      var parg = {};
      parg.Params = {};
      parg.Params.sites = this.codes.sites;
      parg.Params.site = this.sitecode;
      parg.Params.period = this.periode;
      parg.Params.search = this.searchFilter;
      parg.Params.field = this.searchField;
      parg.Params.currentPage = this.currentPage;

      _AppUtil2.default.setSessionValue("site", this.sitecode);
      _AppUtil2.default.setSessionValue("period", this.periode);

      _AppUtil2.default.Forward(this.$router, "IMP", parg);
    }

  },

  mounted: function mounted() {
    var _this6 = this;

    window.addEventListener("popstate", function (event) {
      _this6.closeForm();
    });

    this.userDepts = sessionStorage.getItem("depts");
    this.userRoles = sessionStorage.getItem("roles");

    if (this.$route.params) {
      this.stack = this.$route.params;

      if (this.stack.Params) {
        this.sitecode = this.stack.Params.site;
        this.periode = this.stack.Params.period;
        this.searchFilter = this.stack.Params.search;
        this.searchField = this.stack.Params.field;
        this.currentPage = this.stack.Params.currentPage;
      } else {
        if (window.sessionStorage.getItem("site")) this.sitecode = window.sessionStorage.getItem("site");
        if (window.sessionStorage.getItem("period")) this.periode = window.sessionStorage.getItem("period");
      }
    }

    this.related = _AppSettings2.default.getRelated();
    this.getRecords();
  }
};

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__(76);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _dossier = __webpack_require__(103);

var _dossier2 = _interopRequireDefault(_dossier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var _ref;

    return _ref = {
      searchFields: ["Dossier", "Booker", "Destination", "Accommodation"],
      statusList: [{ cd: 0, va: "Open" }, { cd: 1, va: "Processing" }, { cd: 2, va: "Loaded" }, { cd: 3, va: "Pushed to Racs" }, { cd: 5, va: "Load Error" }, { cd: 6, va: "Push Error" }, { cd: 9, va: "SKIP this Dossier" }],
      QID: _AppUtil2.default.Initialize(this.$router, "Dossier"),
      util: _AppUtil2.default,
      stack: {},
      lang: _AppText2.default.data,
      codes: _AppUtil2.default.codes,
      pageSize: _AppSettings2.default.pageSize,
      serverPaging: false,
      periode: "1",
      periodeLast: "1",
      sitecode: "BC",
      stage: window.stage,

      currentTab: "T1",
      pageCount: 0,
      anonymize: true
    }, (0, _defineProperty3.default)(_ref, 'sitecode', ""), (0, _defineProperty3.default)(_ref, 'viewXmlVisible', false), (0, _defineProperty3.default)(_ref, 'viewDetailsVisible', false), (0, _defineProperty3.default)(_ref, 'outtypes', ["JSON", "XML"]), (0, _defineProperty3.default)(_ref, 'outtype', "JSON"), (0, _defineProperty3.default)(_ref, 'currentTab', "T1"), (0, _defineProperty3.default)(_ref, 'outdata', ""), (0, _defineProperty3.default)(_ref, 'dossier', ""), (0, _defineProperty3.default)(_ref, 'xmldata', ""), (0, _defineProperty3.default)(_ref, 'xmlfile', ""), (0, _defineProperty3.default)(_ref, 'pageTokens', []), (0, _defineProperty3.default)(_ref, 'pageLoaded', false), (0, _defineProperty3.default)(_ref, 'nextPage', 1), (0, _defineProperty3.default)(_ref, 'maxNextValue', 9999), (0, _defineProperty3.default)(_ref, 'editTitle', ""), (0, _defineProperty3.default)(_ref, 'editMode', ""), (0, _defineProperty3.default)(_ref, 'userDepts', ""), (0, _defineProperty3.default)(_ref, 'userRoles', ""), (0, _defineProperty3.default)(_ref, 'APICode', "BasDossier"), (0, _defineProperty3.default)(_ref, 'mainFunc', "Dossier"), (0, _defineProperty3.default)(_ref, 'mainSubject', "Dossier"), (0, _defineProperty3.default)(_ref, 'mainKey', "dosid"), (0, _defineProperty3.default)(_ref, 'mainKeyDesc', "dosid"), (0, _defineProperty3.default)(_ref, 'searchFilter', ''), (0, _defineProperty3.default)(_ref, 'content', []), (0, _defineProperty3.default)(_ref, 'counter', {}), (0, _defineProperty3.default)(_ref, 'related', []), (0, _defineProperty3.default)(_ref, 'currentPage', 0), (0, _defineProperty3.default)(_ref, 'mainTotal', 0), (0, _defineProperty3.default)(_ref, 'searchField', "Booker"), (0, _defineProperty3.default)(_ref, 'detailFin', ""), (0, _defineProperty3.default)(_ref, 'detailPur', ""), (0, _defineProperty3.default)(_ref, 'detailHist', ""), (0, _defineProperty3.default)(_ref, 'detailLocate', ""), (0, _defineProperty3.default)(_ref, 'detailFinLoaded', false), (0, _defineProperty3.default)(_ref, 'detailHistLoaded', false), (0, _defineProperty3.default)(_ref, 'detailLocateLoaded', false), (0, _defineProperty3.default)(_ref, 'detailTransport', ""), (0, _defineProperty3.default)(_ref, 'listLoading', false), (0, _defineProperty3.default)(_ref, 'editFormVisible', false), (0, _defineProperty3.default)(_ref, 'editLoading', false), (0, _defineProperty3.default)(_ref, 'editForm', {}), (0, _defineProperty3.default)(_ref, 'editFormRules', {
      siteid: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
    }), _ref;
  },


  methods: {

    startSearch: function startSearch() {
      if (this.periode.startsWith(".")) {
        this.periode = this.periodeLast;
      } else {
        this.periodeLast = this.periode;
        this.currentPage = 0;
        this.pageTokens = [];
        this.content = [];
        this.maxNextValue = 9999;
        this.nextPage = 1;
        this.pageCount = 0;
        this.getRecords();
      }
    },

    selectPagesize: function selectPagesize(size) {
      _AppSettings2.default.pageSize = size;
      this.currentPage = 0;
      this.nextPage = 1;
      this.pageSize = size;
      this.pageCount = Math.round(this.mainTotal / this.pageSize + 0.5);
      this.getRecords();
    },

    selectPage: function selectPage(page) {},

    loadNextPage: function loadNextPage() {
      this.currentPage = this.nextPage - 1;
      this.getRecords();
    },

    getRecords: function getRecords() {
      var _this = this;

      var parg = {};
      parg.Params = {};
      parg.Params.site = this.sitecode;
      parg.Params.period = this.periode;
      parg.Params.search = this.searchFilter;
      parg.Params.field = this.searchField;
      parg.Params.pageSize = _AppSettings2.default.pageSize;

      if (this.currentPage > 0) parg.Params.pageToken = this.pageTokens[this.currentPage - 1];

      _AppUtil2.default.setSessionValue("site", this.sitecode);
      _AppUtil2.default.setSessionValue("period", this.periode);

      this.listLoading = true;

      _dossier2.default.getPagedList(parg).then(function (res) {
        _AppUtil2.default.processMainResults(res);
        _this.codes = _AppUtil2.default.codes;

        if (_this.pageCount == 0) {
          _this.mainTotal = _AppUtil2.default.header["totalRecs"];
          _this.pageCount = Math.round(_this.mainTotal / _this.pageSize + 0.5);
        }
        if (_this.sitecode == "" && _this.codes.sites[0]) _this.sitecode = _this.codes.sites[0].code;

        if (_this.mainTotal > 0) {
          var ptok = _AppUtil2.default.getMainPayload("PageToken");
          if (ptok.length < 5) _this.maxNextValue = _this.pageTokens.length;else _this.pageLoaded = false;

          _this.pageTokens[_this.currentPage] = ptok;
          _this.content = _AppUtil2.default.getMainPayload(_this.APICode);
          _this.contentSaved = _AppUtil2.default.getMainPayload(_this.APICode);
        } else {
          _this.content = [];
          _this.contentSaved = [];
        }
        _this.listLoading = false;
      }).catch(function (error) {
        _AppUtil2.default.serverError(_this);
      });
    },


    clickTab: function clickTab(tab, event) {
      if (this.currentTab == "FIN" && this.detailFinLoaded == false) this.openTabDetails("fin");else if (this.currentTab == "HIST" && this.detailHistLoaded == false) this.openTabDetails("hist");else if (this.currentTab == "LOCATE" && this.detailLocateLoaded == false) this.openTabDetails("locate");
    },

    openTabDetails: function openTabDetails(loadSet) {
      var _this2 = this;

      if (loadSet != "") {
        var parg = {};
        parg.Params = {};
        parg.Params.site = this.sitecode;
        parg.Params.period = this.periode;
        parg.Params.search = this.searchFilter;
        parg.Params.field = this.searchField;
        parg.Params.dosid = this.editForm['dosid'];
        parg.Params.currentPage = this.currentPage;
        parg.Params.loadset = loadSet;

        _dossier2.default.execute('findet', parg).then(function (res) {
          var d = res.data;
          if (typeof d === "string") d = JSON.parse(res.data);

          if (loadSet == 'fin') {
            _this2.detailFin = d.payload.findet;
            _this2.detailPur = d.payload.finpur;
            if (_this2.detailFin == "") _this2.detailFin = "- No details -";
            if (_this2.detailPur == "") _this2.detailPur = "- No details -";

            _this2.detailFinLoaded = true;
          } else if (loadSet == 'hist') {
            _this2.detailHist = d.payload.findet;
            _this2.detailHistLoaded = true;
          } else if (loadSet == 'locate') {
            _this2.detailLocate = d.payload.verblijf;
            _this2.detailTransport = d.payload.transport;
            if (_this2.detailLocate == "") _this2.detailLocate = "- No details -";
            if (_this2.detailTransport == "") _this2.detailTransport = "- No details -";
            _this2.detailLocateLoaded = true;
          }
        }).catch(function (error) {
          _AppUtil2.default.serverError(_this2);
        });
      }
    },


    openRelated: function openRelated(row) {},

    handleDel: function handleDel(row) {
      var _this3 = this;

      this.$confirm(_AppText2.default.getText("sdelM", this.mainSubject, row[this.mainKeyDesc]), 'Confirm', {
        type: 'warning', title: _AppText2.default.getText("sdelT", this.mainSubject)
      }).then(function () {
        _this3.listLoading = true;

        var parg = {};
        parg.Params = {};
        parg.Params['site'] = row.site;
        parg.Params['dosid'] = row.dosid;

        _dossier2.default.removeRecord(parg).then(function (res) {
          _this3.listLoading = false;
          _this3.$notify({
            title: _AppText2.default.data.conf, type: 'success',
            message: _AppText2.default.getText("delOK", _this3.mainSubject, row[_this3.mainKey])
          });
          _this3.getRecords();
        });
      }).catch(function () {});
    },

    handleEdit: function handleEdit(row) {
      this.editMode = "save";
      this.editTitle = _AppText2.default.getText("modM", this.mainSubject, row[this.mainKey]);
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)({}, row);
      this.detailFin = "";
      this.detailPur = "";
      this.detailHist = "";
      this.detailLocate = "";
      this.detailFinLoaded = false;
      this.detailHistLoaded = false;
      this.detailLocateLoaded = false;
      this.currentTab = "T1";
    },

    handleView: function handleView(row) {
      this.getDetailData(row.dosid);
    },

    reloadData: function reloadData() {
      this.getDetailData(this.dossier);
    },

    getDetailData: function getDetailData(dosid) {
      var _this4 = this;

      var parg = {};
      parg.Params = {};
      parg.Params.site = this.sitecode;
      parg.Params.dosid = dosid;
      this.dossier = dosid;
      parg.Params.period = this.periode;
      parg.Params.search = this.searchFilter;
      parg.Params.field = this.searchField;
      parg.Params.currentPage = this.currentPage;

      parg.Params["type"] = this.outtype;

      _dossier2.default.execute("detail", parg).then(function (res) {
        var d = res.data;
        if (typeof d === "string") d = JSON.parse(res.data);
        _this4.outdata = d.payload.outdata;
        _this4.viewDetailsVisible = true;
        _this4.listLoading = false;
      });
    },

    handleXml: function handleXml(row) {
      var _this5 = this;

      var parg = {};
      parg.Params = {};
      parg.Params.site = this.sitecode;
      parg.Params.dosid = row.dosid;
      parg.Params.period = this.periode;
      parg.Params.search = this.searchFilter;
      parg.Params.field = this.searchField;
      parg.Params.currentPage = this.currentPage;

      parg.Params = {};
      parg.Params.site = this.sitecode;
      parg.Params.dosid = row.dosid;
      parg.Params.period = this.periode;
      parg.Params.search = this.searchFilter;
      parg.Params.field = this.searchField;
      parg.Params.currentPage = this.currentPage;

      this.listLoading = true;

      _dossier2.default.execute("xml", parg).then(function (res) {
        var d = res.data;
        if (typeof d === "string") d = JSON.parse(res.data);

        _this5.xmldata = d.payload.xml;
        _this5.xmlfile = d.payload.xmlfile;
        _this5.dossier = parg.Params.dosid;
        _this5.viewXmlVisible = true;
        _this5.listLoading = false;
      });
    },

    handleImport: function handleImport() {
      var parg = {};
      parg.Params = {};
      parg.Params.sites = this.codes.sites;
      parg.Params.site = this.sitecode;
      parg.Params.period = this.periode;
      parg.Params.search = this.searchFilter;
      parg.Params.field = this.searchField;
      parg.Params.currentPage = this.currentPage;

      _AppUtil2.default.setSessionValue("site", this.sitecode);
      _AppUtil2.default.setSessionValue("period", this.periode);

      _AppUtil2.default.Forward(this.$router, "IMP", parg);
    },

    editSubmit: function editSubmit() {
      var _this6 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this6.editLoading = true;

          var parg = (0, _assign2.default)({}, _this6.editForm);

          if (_this6.editMode == "add") {
            _dossier2.default.addRecord(parg).then(function (res) {
              if (res.data.header.OK) _this6.$notify({ title: _AppText2.default.data.done, type: 'success',
                message: _AppText2.default.getText("addOK", _this6.mainSubject, _this6.editForm.loaderversion) });else _this6.$notify({ title: "Error", type: 'error', message: res.data.header.message });
              _this6.$refs['editForm'].resetFields();
              _this6.editLoading = false;
              _this6.editFormVisible = false;
              _this6.getRecords();
            });
          } else {
            _dossier2.default.saveRecord(parg).then(function (res) {
              if (res.data.header.OK) _this6.$notify({ title: _AppText2.default.data.done, type: 'success',
                message: _AppText2.default.getText("modOK", _this6.mainSubject, _this6.editForm.loaderversion) });else _this6.$notify({ title: "Error", type: 'error', message: res.data.header.message });
              _this6.$refs['editForm'].resetFields();
              _this6.editLoading = false;
              _this6.editFormVisible = false;
              _this6.getRecords();
            });
          }
        }
      });
    }

  },

  mounted: function mounted() {
    var _this7 = this;

    window.addEventListener("popstate", function (event) {
      _this7.closeForm();
    });

    this.userDepts = sessionStorage.getItem("depts");
    this.userRoles = sessionStorage.getItem("roles");

    if (this.$route.params) {
      this.stack = this.$route.params;

      if (this.stack.Params) {
        this.sitecode = this.stack.Params.site;
        this.periode = this.stack.Params.period;
        this.searchFilter = this.stack.Params.search;
        this.searchField = this.stack.Params.field;
        this.currentPage = this.stack.Params.currentPage;
      } else {
        if (window.sessionStorage.getItem("site")) this.sitecode = window.sessionStorage.getItem("site");
        if (window.sessionStorage.getItem("period")) this.periode = window.sessionStorage.getItem("period");
      }
    }

    this.related = _AppSettings2.default.getRelated();
    this.getRecords();
  }
};

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _maintenance = __webpack_require__(299);

var _maintenance2 = _interopRequireDefault(_maintenance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      QID: _AppUtil2.default.Initialize(this.$router, "MAINT"),
      util: _AppUtil2.default,
      stack: {},
      lang: _AppText2.default.data,
      APICode: "maintenance",
      mainFunc: "Generic Maintenance",
      mainSubject: "Dossier",
      mainKey: "dosid",
      mainKeyDesc: "dosid",
      site: "",
      action: "",
      results: "",
      dosid: "",
      key: "",
      sites: [],
      options: [],
      tables: [],
      table: "",
      data: [],
      session: {},
      content: [],
      listLoading: false,
      editForm: {},
      editFormVisible: false,
      editLoading: false,
      editMode: '',
      editTitle: '',

      editFormRules: {
        name: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
      }

    };
  },

  methods: {
    htmlData: function htmlData(val) {
      var ret = "" + val;
      return ret.replace(/\\/g, '');
    },
    Initialize: function Initialize() {
      var _this = this;

      this.listLoading = true;

      var parg = {};
      parg.Module = "maintenance";

      _maintenance2.default.execute("init", parg).then(function (res) {
        _AppUtil2.default.processMainResults(res);
        _this.sites = _AppUtil2.default.codes.sites;
        _this.options = _AppUtil2.default.getMainPayload("options");
        _this.tables = _AppUtil2.default.getMainPayload("tables");
        _this.editFormVisible = true;
        _this.listLoading = false;
      });
    },

    closeForm: function closeForm() {
      this.selectorVisible = false;
      var parg = this.stack;
      _AppUtil2.default.Forward(this.$router, "DOS", parg);
    },

    Execute: function Execute() {
      var _this2 = this;

      this.listLoading = true;
      var parg = {};

      parg.Params = {};
      parg.Params.site = this.site;
      parg.Params.todo = this.action;
      parg.Params.dosid = this.dosid;
      parg.Params.table = this.table;
      parg.Params.key = this.key;

      _maintenance2.default.execute("exec", parg).then(function (res) {
        _AppUtil2.default.processMainResults(res);
        _this2.results = _AppUtil2.default.getMainPayload("result");
        _this2.editFormVisible = true;
        _this2.listLoading = false;
      });
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    window.addEventListener("popstate", function (event) {
      _this3.closeForm();
    });

    this.Initialize();
  }
};

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _report = __webpack_require__(300);

var _report2 = _interopRequireDefault(_report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      QID: _AppUtil2.default.Initialize(this.$router, "Report"),
      util: _AppUtil2.default,
      stack: {},
      lang: _AppText2.default.data,
      codes: _AppUtil2.default.codes,
      pageSize: _AppSettings2.default.pageSize,
      serverPaging: false,
      listLoading: false,

      outtypes: ["TABLE", "JSON", "XML", "CSV_NL", "CSV_EN"],
      bookStatSel: ["ok", "okx"],

      periodFrom: "",
      periodTill: "",
      output: "TABLE",
      sitecode: "",
      content: "",
      editTitle: "",
      editMode: "",
      APICode: "Report",
      mainFunc: "Report",
      mainSubject: "Report",
      buttonType: "primary",
      bookStatusView: false,
      openApp: true,
      manType: false,

      allviews: [],
      selectviews: [],

      report: [],
      reportsel: "",
      lastType: "",

      reportdata: "",
      reportLoaded: false,
      periodsel: "1",
      periodLast: "1"
    };
  },


  methods: {
    closeForm: function closeForm() {
      this.selectorVisible = false;
    },

    checkPeriode: function checkPeriode() {
      if (this.periodsel.startsWith(".")) this.periodsel = this.periodLast;else this.periodLast = this.periodsel;
    },
    filterReports: function filterReports() {
      this.selectviews = [];
      for (var i = 0; i < this.allviews.length; i++) {
        if (this.allviews[i].sitelist != undefined && (this.allviews[i].sitelist === "*" || this.allviews[i].sitelist.includes(this.sitecode))) {
          this.selectviews.push({ code: this.allviews[i].code, name: this.allviews[i].name });
        }
      }
    },
    showReport: function showReport() {
      this.listLoading = true;
      this.getRecords();
    },
    getRecords: function getRecords() {
      var _this = this;

      this.periodLast = this.periodsel;
      this.listLoading = true;
      this.buttonType = "primary-outline";

      var parg = {};
      parg.Params = {};
      parg.Params.site = this.sitecode;
      parg.Params.report = this.reportsel;
      parg.Params.manType = this.manType;
      parg.Params.typeList = this.bookStatSel.join(",");

      if (this.output == "CSV_NL") {
        parg.Params.outtype = "CSV";
        parg.Params.csvsepp = ";";
      } else if (this.output == "CSV_EN") {
        parg.Params.outtype = "CSV";
        parg.Params.csvsepp = ",";
      } else parg.Params.outtype = this.output;

      if (this.periodsel == 'man') parg.Params.period = "man," + this.periodFrom + "," + this.periodTill;else parg.Params.period = this.periodsel;

      window.sessionStorage.setItem("site", this.sitecode);
      window.sessionStorage.setItem("periodsel", parg.Params.period);
      window.sessionStorage.setItem("reportsel", this.reportsel);

      this.reportLoaded = false;

      _report2.default.execute("", parg).then(function (res) {
        _AppUtil2.default.processMainResults(res);

        _this.codes = _AppUtil2.default.codes;
        if (_this.periodsel == "") _this.periodsel = _AppUtil2.default.getMainHeader("lastperiod");
        if (_this.sitecode == "" && _this.codes.sites[0]) _this.sitecode = _this.codes.sites[0].code;

        _this.listLoading = false;
        _this.buttonType = "primary";

        if (res.data.payload.report) {
          _this.reportdata = _AppUtil2.default.getMainPayload("report");
          _this.lastType = _this.output;
          _this.reportLoaded = true;
        }

        _this.allviews = _AppUtil2.default.getMainPayload("views");
        _this.filterReports();
      }).catch(function (error) {
        _AppUtil2.default.serverError(_this);
        console.log("ERROR: " + _this.message);
      });
    },


    download: function download() {
      var anchor = document.createElement('a');
      if (this.output == "TABLE") {
        anchor.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.reportdata);
        anchor.download = 'Content_' + this.periodsel + '.txt';
      } else if (this.output == "JSON") {
        anchor.href = 'data:' + (this.openApp ? "application/json" : "text/plain") + ';charset=utf-8,' + encodeURIComponent(this.reportdata);
        anchor.download = 'Content_' + this.periodsel + '.json';
      } else if (this.output == "XML") {
        anchor.href = 'data:' + (this.openApp ? "application/xml" : "text/plain") + ';charset=utf-8,' + encodeURIComponent(this.reportdata);
        anchor.download = 'Content_' + this.periodsel + '.xml';
      } else if (this.output == "CSV" || this.output == "CSV_NL" || this.output == "CSV_EN") {
        anchor.href = 'data:' + (this.openApp ? "text/csv" : "text/plain") + ';charset=utf-8,' + encodeURIComponent(this.reportdata);
        anchor.download = 'Content_' + this.periodsel + '.csv';
      }

      anchor.target = '_blank';
      anchor.click();
    }

  },

  mounted: function mounted() {
    var _this2 = this;

    window.addEventListener("popstate", function (event) {
      _this2.closeForm();
    });

    if (this.$route.params) {
      this.stack = this.$route.params;
    }

    if (window.sessionStorage.getItem("site")) this.sitecode = window.sessionStorage.getItem("site");
    if (window.sessionStorage.getItem("periodsel")) {
      var arr = window.sessionStorage.getItem("periodsel").split(",");
      this.periodsel = arr[0];
      if (arr.length > 0) this.periodFrom = arr[1];
      if (arr.length > 1) this.periodTill = arr[2];
    }

    this.getRecords();
  }
};

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _site = __webpack_require__(301);

var _site2 = _interopRequireDefault(_site);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      QID: _AppUtil2.default.Initialize(this.$router, "S"),
      util: _AppUtil2.default,
      stack: {},
      forceLoad: false,
      lang: _AppText2.default.data,
      codes: _AppUtil2.default.codes,
      allowed: _AppUtil2.default.getAuthMode(sessionStorage.getItem('userLevel'), "site"),
      pageSize: _AppSettings2.default.pageSize,
      serverPaging: false,
      searchDone: false,
      stage: window.stage,

      anonymize: true,
      numRecs: 1000,
      sitecode: "",

      editTitle: "",
      editMode: "",
      userDepts: "",
      userRoles: "",
      APICode: "BasSite",
      mainFunc: "site",
      mainSubject: "site",
      mainKey: "code",
      mainKeyDesc: "name",
      searchFilter: '',
      content: [],
      counter: {},
      related: [],
      currentPage: 1,
      mainTotal: 0,
      lastSearch: "",
      pagewidth: 0,

      listLoading: false,
      editFormVisible: false,
      editLoading: false,
      editForm: {},
      editFormRules: {
        setcode: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
      }

    };
  },


  methods: {
    closeForm: function closeForm() {
      this.selectorVisible = false;
      _AppUtil2.default.Forward(this.$router, "AAAA", this.stack);
    },

    startSearch: function startSearch() {
      if (this.lastSearch != this.searchFilter || this.forceLoad) {
        this.lastSearch = this.searchFilter;
        this.currentPage = 1;
        this.content = [];
        this.lastPage = 1;
        this.getRecords();
      }
    },

    selectPagesize: function selectPagesize(size) {
      _AppSettings2.default.pageSize = size;
      this.showPagedData();
    },
    selectPage: function selectPage(page) {
      this.currentPage = page;
      this.showPagedData();
    },
    showPagedData: function showPagedData() {
      if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
    },

    getRecords: function getRecords() {
      var _this = this;

      var parg = {};
      parg.Params = {};
      parg.Params.search = this.searchFilter;

      this.listLoading = true;

      _site2.default.execute("list", parg).then(function (res) {

        _AppUtil2.default.processMainResults(res);
        _this.codes = _AppUtil2.default.codes;
        _this.mainTotal = _AppUtil2.default.payload[_this.APICode].length;

        if (_this.mainTotal > 0) {
          if (_this.serverPaging) _this.content = _AppUtil2.default.getMainPayload(_this.APICode);else {
            _this.contentSaved = _AppUtil2.default.getMainPayload(_this.APICode);
            if (_this.contentSaved.length > 0) _this.selectPage(1);
          }
        } else {
          _this.content = [];
          _this.contentSaved = [];
        }
        _this.listLoading = false;
      }).catch(function (error) {
        _AppUtil2.default.serverError(_this);
      });
    },

    handleDel: function handleDel(row) {
      var _this2 = this;

      this.$confirm(_AppText2.default.getText("sdelM", this.mainSubject, row[this.mainKeyDesc]), 'Confirm', {
        type: 'warning', title: _AppText2.default.getText("sdelT", this.mainSubject)
      }).then(function () {
        _this2.listLoading = true;

        var parg = {};
        parg["Action"] = "del";
        parg["Record"] = (0, _assign2.default)({}, row);

        _site2.default.removeRecord(parg).then(function (res) {
          _this2.listLoading = false;
          _this2.$notify({
            title: _AppText2.default.data.conf, type: 'success',
            message: _AppText2.default.getText("delOK", _this2.mainSubject, row[_this2.mainKey])
          });
          _this2.getRecords();
        });
      }).catch(function () {});
    },

    handleEdit: function handleEdit(row) {
      this.editMode = "save";
      this.editTitle = _AppText2.default.getText("modM", this.mainSubject, row[this.mainKey]);
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)({}, row);
    },

    handleAdd: function handleAdd() {
      this.editMode = "add";
      this.editTitle = _AppText2.default.getText("addM", this.mainSubject);
      this.editFormVisible = true;
      this.editForm = {};
      this.editForm["fieldname"] = "value";
      this.editForm["filter"] = "mean";
    },

    editSubmit: function editSubmit() {
      var _this3 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this3.editLoading = true;

          var parg = {};
          parg["Record"] = (0, _assign2.default)({}, _this3.editForm);

          if (_this3.editMode == "add") {
            parg["Action"] = "add";
            _site2.default.addRecord(parg).then(function (res) {
              _AppUtil2.default.processMainResults(res);
              if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
                message: _AppText2.default.getText("addOK", _this3.mainSubject, _this3.editForm.title) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });
              _this3.$refs['editForm'].resetFields();
              _this3.editLoading = false;
              _this3.editFormVisible = false;
              _this3.getRecords();
            });
          } else {
            parg["Action"] = "save";
            _site2.default.saveRecord(parg).then(function (res) {
              _AppUtil2.default.processMainResults(res);
              if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
                message: _AppText2.default.getText("modOK", _this3.mainSubject, _this3.editForm.title) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });
              _this3.$refs['editForm'].resetFields();
              _this3.editLoading = false;
              _this3.editFormVisible = false;
              _this3.getRecords();
            });
          }
        }
      });
    },

    reportWindowSize: function reportWindowSize() {
      this.pagewidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

  },

  mounted: function mounted() {
    var _this4 = this;

    window.onresize = this.reportWindowSize;
    this.reportWindowSize;

    window.addEventListener("popstate", function (event) {
      _this4.closeForm();
    });

    this.userDepts = sessionStorage.getItem("depts");
    this.userRoles = sessionStorage.getItem("roles");

    if (this.$route.params) {
      this.stack = this.$route.params;
      this.searchFilter = this.stack.search;
      this.lastPage = this.stack.currentPage;
      if (this.stack.modus != null) this.searchModus = this.stack.modus;
    }

    this.reportWindowSize();
    this.listLoading = true;
    this.startSearch();
  }
};

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _supplier = __webpack_require__(302);

var _supplier2 = _interopRequireDefault(_supplier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			QID: _AppUtil2.default.Initialize(this.$router, "SUP"),
			util: _AppUtil2.default,
			stack: {},
			lang: _AppText2.default.data,
			codes: _AppUtil2.default.codes,
			pageSize: _AppSettings2.default.pageSize,
			serverPaging: false,
			stage: window.stage,

			editTitle: "",
			editMode: "",
			userDepts: "",
			userRoles: "",
			APICode: "BasSupplier",
			mainFunc: "Supplier",
			mainSubject: "Supplier",
			mainKey: "code",
			mainKeyDesc: "name",
			searchFilter: '',
			content: [],
			counter: {},
			related: [],
			currentPage: 1,
			mainTotal: 0,

			listLoading: false,
			editFormVisible: false,
			editLoading: false,
			editForm: {},
			editFormRules: {
				code: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
			}

		};
	},


	methods: {
		closeForm: function closeForm() {
			this.selectorVisible = false;
			this.$router.push({ name: 'Employees', params: this.stack });
		},

		startSearch: function startSearch() {
			this.currentPage = 1;
			this.content = [];
			this.getRecords();
		},

		selectPagesize: function selectPagesize(size) {
			_AppSettings2.default.pageSize = size;
			this.showPagedData();
		},
		selectPage: function selectPage(page) {
			this.currentPage = page;
			this.showPagedData();
		},
		showPagedData: function showPagedData() {
			if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
		},

		getRecords: function getRecords() {
			var _this = this;

			var parg = {};
			parg.Params = {};
			parg.Params.search = this.searchFilter;

			this.listLoading = true;

			_supplier2.default.getListPage(parg).then(function (res) {
				_AppUtil2.default.processMainResults(res);
				_this.codes = _AppUtil2.default.codes;
				_this.mainTotal = _AppUtil2.default.payload[_this.APICode].length;

				if (_this.mainTotal > 0) {
					if (_this.serverPaging) _this.content = _AppUtil2.default.getMainPayload(_this.APICode);else {
						_this.contentSaved = _AppUtil2.default.getMainPayload(_this.APICode);
						if (_this.contentSaved.length > 0) _this.selectPage(1);
					}
				} else {
					_this.content = [];
					_this.contentSaved = [];
				}
				_this.listLoading = false;
			}).catch(function (error) {
				_AppUtil2.default.serverError(_this);
			});
		},


		openRelated: function openRelated(row) {},

		handleDel: function handleDel(row) {
			var _this2 = this;

			this.$confirm(_AppText2.default.getText("sdelM", this.mainSubject, row[this.mainKeyDesc]), 'Confirm', {
				type: 'warning', title: _AppText2.default.getText("sdelT", this.mainSubject)
			}).then(function () {
				_this2.listLoading = true;

				var parg = {};
				parg["Action"] = "del";
				parg["Record"] = (0, _assign2.default)({}, row);

				_supplier2.default.removeRecord(parg).then(function (res) {
					_this2.listLoading = false;
					_this2.$notify({
						title: _AppText2.default.data.conf, type: 'success',
						message: _AppText2.default.getText("delOK", _this2.mainSubject, row[_this2.mainKey])
					});
					_this2.getRecords();
				});
			}).catch(function () {});
		},

		handleEdit: function handleEdit(row) {
			this.editMode = "save";
			this.editTitle = _AppText2.default.getText("modM", this.mainSubject, row[this.mainKey]);
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.editMode = "add";
			this.editTitle = _AppText2.default.getText("addM", this.mainSubject);
			this.editFormVisible = true;
			this.editForm = {};
		},

		editSubmit: function editSubmit() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					_this3.editLoading = true;

					var parg = {};
					parg["Record"] = (0, _assign2.default)({}, _this3.editForm);

					if (_this3.editMode == "add") {
						parg["Action"] = "add";
						_supplier2.default.addRecord(parg).then(function (res) {
							_AppUtil2.default.processMainResults(res);
							if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
								message: _AppText2.default.getText("addOK", _this3.mainSubject, _this3.editForm.name) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });
							_this3.$refs['editForm'].resetFields();
							_this3.editLoading = false;
							_this3.editFormVisible = false;
							_this3.getRecords();
						});
					} else {
						parg["Action"] = "save";
						_supplier2.default.saveRecord(parg).then(function (res) {
							_AppUtil2.default.processMainResults(res);
							if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
								message: _AppText2.default.getText("modOK", _this3.mainSubject, _this3.editForm.name) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });
							_this3.$refs['editForm'].resetFields();
							_this3.editLoading = false;
							_this3.editFormVisible = false;
							_this3.getRecords();
						});
					}
				}
			});
		}

	},

	mounted: function mounted() {
		var _this4 = this;

		window.addEventListener("popstate", function (event) {
			_this4.closeForm();
		});

		this.userDepts = sessionStorage.getItem("depts");
		this.userRoles = sessionStorage.getItem("roles");

		if (this.$route.params) {
			this.stack = this.$route.params;
		}

		this.related = _AppSettings2.default.getRelated();
		this.getRecords();
	}
};

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _view = __webpack_require__(303);

var _view2 = _interopRequireDefault(_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      QID: _AppUtil2.default.Initialize(this.$router, "S"),
      util: _AppUtil2.default,
      stack: {},
      forceLoad: false,
      lang: _AppText2.default.data,
      codes: _AppUtil2.default.codes,
      allowed: _AppUtil2.default.getAuthMode(sessionStorage.getItem('userLevel'), "view"),
      pageSize: _AppSettings2.default.pageSize,
      serverPaging: false,
      searchDone: false,
      stage: window.stage,

      anonymize: true,
      numRecs: 1000,
      viewcode: "",

      editTitle: "",
      editMode: "",
      userDepts: "",
      userRoles: "",
      APICode: "BasView",
      mainFunc: "view",
      mainSubject: "view",
      mainKey: "code",
      mainKeyDesc: "name",
      searchFilter: '',
      content: [],
      counter: {},
      related: [],
      currentPage: 1,
      mainTotal: 0,
      lastSearch: "",
      pagewidth: 0,

      listLoading: false,
      editFormVisible: false,
      editLoading: false,
      editForm: {},
      editFormRules: {
        setcode: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
      }

    };
  },


  methods: {
    closeForm: function closeForm() {
      this.selectorVisible = false;
      _AppUtil2.default.Forward(this.$router, "AAAA", this.stack);
    },

    startSearch: function startSearch() {
      if (this.lastSearch != this.searchFilter || this.forceLoad) {
        this.lastSearch = this.searchFilter;
        this.currentPage = 1;
        this.content = [];
        this.lastPage = 1;
        this.getRecords();
      }
    },

    selectPagesize: function selectPagesize(size) {
      _AppSettings2.default.pageSize = size;
      this.showPagedData();
    },
    selectPage: function selectPage(page) {
      this.currentPage = page;
      this.showPagedData();
    },
    showPagedData: function showPagedData() {
      if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
    },

    getRecords: function getRecords() {
      var _this = this;

      var parg = {};
      parg.Params = {};
      parg.Params.search = this.searchFilter;

      this.listLoading = true;

      _view2.default.execute("list", parg).then(function (res) {

        _AppUtil2.default.processMainResults(res);
        _this.codes = _AppUtil2.default.codes;
        _this.mainTotal = _AppUtil2.default.payload[_this.APICode].length;

        if (_this.mainTotal > 0) {
          if (_this.serverPaging) _this.content = _AppUtil2.default.getMainPayload(_this.APICode);else {
            _this.contentSaved = _AppUtil2.default.getMainPayload(_this.APICode);
            if (_this.contentSaved.length > 0) _this.selectPage(1);
          }
        } else {
          _this.content = [];
          _this.contentSaved = [];
        }
        _this.listLoading = false;
      }).catch(function (error) {
        _AppUtil2.default.serverError(_this);
      });
    },

    handleDel: function handleDel(row) {
      var _this2 = this;

      this.$confirm(_AppText2.default.getText("sdelM", this.mainSubject, row[this.mainKeyDesc]), 'Confirm', {
        type: 'warning', title: _AppText2.default.getText("sdelT", this.mainSubject)
      }).then(function () {
        _this2.listLoading = true;

        var parg = {};
        parg["Action"] = "del";
        parg["Record"] = (0, _assign2.default)({}, row);

        _view2.default.removeRecord(parg).then(function (res) {
          _this2.listLoading = false;
          _this2.$notify({
            title: _AppText2.default.data.conf, type: 'success',
            message: _AppText2.default.getText("delOK", _this2.mainSubject, row[_this2.mainKey])
          });
          _this2.getRecords();
        });
      }).catch(function () {});
    },

    handleEdit: function handleEdit(row) {
      this.editMode = "save";
      this.editTitle = _AppText2.default.getText("modM", this.mainSubject, row[this.mainKey]);
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)({}, row);
    },

    handleAdd: function handleAdd() {
      this.editMode = "add";
      this.editTitle = _AppText2.default.getText("addM", this.mainSubject);
      this.editFormVisible = true;
      this.editForm = {};
      this.editForm["fieldname"] = "value";
      this.editForm["filter"] = "mean";
    },

    editSubmit: function editSubmit() {
      var _this3 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this3.editLoading = true;

          var parg = {};
          parg["Record"] = (0, _assign2.default)({}, _this3.editForm);

          if (_this3.editMode == "add") {
            parg["Action"] = "add";
            _view2.default.addRecord(parg).then(function (res) {
              _AppUtil2.default.processMainResults(res);
              if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
                message: _AppText2.default.getText("addOK", _this3.mainSubject, _this3.editForm.title) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });
              _this3.$refs['editForm'].resetFields();
              _this3.editLoading = false;
              _this3.editFormVisible = false;
              _this3.getRecords();
            });
          } else {
            parg["Action"] = "save";
            _view2.default.saveRecord(parg).then(function (res) {
              _AppUtil2.default.processMainResults(res);
              if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
                message: _AppText2.default.getText("modOK", _this3.mainSubject, _this3.editForm.title) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });
              _this3.$refs['editForm'].resetFields();
              _this3.editLoading = false;
              _this3.editFormVisible = false;
              _this3.getRecords();
            });
          }
        }
      });
    },

    reportWindowSize: function reportWindowSize() {
      this.pagewidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

  },

  mounted: function mounted() {
    var _this4 = this;

    window.onresize = this.reportWindowSize;
    this.reportWindowSize;

    window.addEventListener("popstate", function (event) {
      _this4.closeForm();
    });

    this.userDepts = sessionStorage.getItem("depts");
    this.userRoles = sessionStorage.getItem("roles");

    if (this.$route.params) {
      this.stack = this.$route.params;
      this.searchFilter = this.stack.search;
      this.lastPage = this.stack.currentPage;
      if (this.stack.modus != null) this.searchModus = this.stack.modus;
    }

    this.reportWindowSize();
    this.listLoading = true;
    this.startSearch();
  }
};

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _xstat = __webpack_require__(165);

var _xstat2 = _interopRequireDefault(_xstat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			QID: _AppUtil2.default.Initialize(this.$router, "XST"),
			util: _AppUtil2.default,
			stack: {},
			lang: _AppText2.default.data,
			codes: _AppUtil2.default.codes,
			pageSize: _AppSettings2.default.pageSize,
			serverPaging: false,
			stat: "",
			editTitle: "",
			editMode: "",
			APICode: "XStat",
			mainFunc: "XStat",
			mainSubject: "XStat",
			mainKey: "code",
			mainKeyDesc: "code",
			searchFilter: '',
			content: [],
			counter: {},
			related: [],
			currentPage: 1,
			mainTotal: 0,

			listLoading: false,
			editFormVisible: false,
			editLoading: false,
			editForm: {},
			editFormRules: {
				code: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
			}

		};
	},


	methods: {
		closeForm: function closeForm() {
			this.selectorVisible = false;
			this.$router.push({ name: 'Statistics', params: this.stack });
		},

		openGroup: function openGroup() {
			this.content = [];
			this.getRecords();
		},

		selectPagesize: function selectPagesize(size) {
			_AppSettings2.default.pageSize = size;
			this.showPagedData();
		},
		selectPage: function selectPage(page) {
			this.currentPage = page;
			this.showPagedData();
		},
		showPagedData: function showPagedData() {
			if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
		},

		getRecords: function getRecords() {
			var _this = this;

			var parg = {};
			parg.Params = {};
			parg.Params.code = this.stat;
			parg.Params.path = this.$route.path;

			this.listLoading = true;

			_xstat2.default.getSanityPage(parg).then(function (res) {
				_AppUtil2.default.processMainResults(res);
				_this.content = [];

				if (_this.codes) _this.codes = _AppUtil2.default.codes;

				if (_AppUtil2.default.getMainPayload(_this.APICode)) {
					_this.content = _AppUtil2.default.getMainPayload(_this.APICode);
					_this.mainTotal = _this.content.length;
				} else {
					_this.content = [];
					_this.contentSaved = [];
				}
				_this.listLoading = false;
			}).catch(function (error) {
				_AppUtil2.default.serverError(_this);
			});
		},


		openRelated: function openRelated(row) {},

		handleDel: function handleDel(row) {
			var _this2 = this;

			this.$confirm(_AppText2.default.getText("sdelM", this.mainSubject, row[this.mainKeyDesc]), 'Confirm', {
				type: 'warning', title: _AppText2.default.getText("sdelT", this.mainSubject)
			}).then(function () {
				_this2.listLoading = true;

				var parg = (0, _assign2.default)({}, row);

				_xstat2.default.removeRecord(parg).then(function (res) {
					_this2.listLoading = false;
					_this2.$notify({
						title: _AppText2.default.data.conf, type: 'success',
						message: _AppText2.default.getText("delOK", _this2.mainSubject, row[_this2.mainKey])
					});
					_this2.getRecords();
				});
			}).catch(function () {});
		},
		rowClass: function rowClass(row, index) {
			return "row";
		},

		handleEdit: function handleEdit(row) {
			this.editMode = "save";
			this.editTitle = _AppText2.default.getText("modM", this.mainSubject, row[this.mainKey]);
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.editMode = "add";
			this.editTitle = _AppText2.default.getText("addM", this.mainSubject);
			this.editFormVisible = true;
			this.editForm = {};
			this.editForm["statcode"] = this.code;
		},

		editSubmit: function editSubmit() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					_this3.editLoading = true;

					var parg = {};
					parg.Params = {};
					parg.Record = (0, _assign2.default)({}, _this3.editForm);

					if (_this3.editMode == "add") {
						_xstat2.default.addRecord(parg).then(function (res) {
							_AppUtil2.default.processMainResults(res);
							if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
								message: _AppText2.default.getText("addOK", _this3.mainSubject, _this3.editForm.showorder) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });
							_this3.$refs['editForm'].resetFields();
							_this3.editLoading = false;
							_this3.editFormVisible = false;
							_this3.getRecords();
						});
					} else {
						_xstat2.default.saveRecord(parg).then(function (res) {
							_AppUtil2.default.processMainResults(res);
							if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
								message: _AppText2.default.getText("modOK", _this3.mainSubject, _this3.editForm.showorder) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });
							_this3.$refs['editForm'].resetFields();
							_this3.editLoading = false;
							_this3.editFormVisible = false;
							_this3.getRecords();
						});
					}
				}
			});
		}

	},

	mounted: function mounted() {
		var _this4 = this;

		window.addEventListener("popstate", function (event) {
			_this4.closeForm();
		});

		if (this.$route.params) {
			this.stack = this.$route.params;
		}

		this.getRecords();
	}
};

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _xstat = __webpack_require__(165);

var _xstat2 = _interopRequireDefault(_xstat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			QID: _AppUtil2.default.Initialize(this.$router, "XST"),
			util: _AppUtil2.default,
			stack: {},
			lang: _AppText2.default.data,
			codes: _AppUtil2.default.codes,
			pageSize: _AppSettings2.default.pageSize,
			serverPaging: false,
			stat: "",
			editTitle: "",
			editMode: "",
			APICode: "XStat",
			mainFunc: "XStat",
			mainSubject: "XStat",
			mainKey: "code",
			mainKeyDesc: "code",
			searchFilter: '',
			content: [],
			counter: {},
			related: [],
			currentPage: 1,
			mainTotal: 0,
			MessagesVisible: false,
			messages: "",

			listLoading: false,
			editFormVisible: false,
			editLoading: false,
			editForm: {},
			editFormRules: {
				code: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
			}

		};
	},


	methods: {
		closeForm: function closeForm() {
			this.selectorVisible = false;
			this.$router.push({ name: 'Statistics', params: this.stack });
		},

		openGroup: function openGroup() {
			this.content = [];
			this.getRecords();
		},

		selectPagesize: function selectPagesize(size) {
			_AppSettings2.default.pageSize = size;
			this.showPagedData();
		},
		selectPage: function selectPage(page) {
			this.currentPage = page;
			this.showPagedData();
		},
		showPagedData: function showPagedData() {
			if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
		},

		showLog: function showLog(row) {
			this.messages = row.runlog;
			this.MessagesVisible = true;
		},

		getRecords: function getRecords() {
			var _this = this;

			var parg = {};
			parg.Params = {};
			parg.Params.code = this.stat;
			parg.Params.path = this.$route.path;

			this.listLoading = true;

			_xstat2.default.getListPage(parg).then(function (res) {
				_AppUtil2.default.processMainResults(res);
				_this.content = [];

				if (_this.codes) _this.codes = _AppUtil2.default.codes;

				if (_AppUtil2.default.getMainPayload(_this.APICode)) {
					_this.contentSaved = _AppUtil2.default.getMainPayload(_this.APICode);
					_this.mainTotal = _this.contentSaved.length;
					if (_this.contentSaved.length > 0) _this.selectPage(1);
				} else {
					_this.content = [];
					_this.contentSaved = [];
					_this.messages = "";
				}
				_this.listLoading = false;
			}).catch(function (error) {
				_AppUtil2.default.serverError(_this);
			});
		},


		openRelated: function openRelated(row) {},

		handleDel: function handleDel(row) {
			var _this2 = this;

			this.$confirm(_AppText2.default.getText("sdelM", this.mainSubject, row[this.mainKeyDesc]), 'Confirm', {
				type: 'warning', title: _AppText2.default.getText("sdelT", this.mainSubject)
			}).then(function () {
				_this2.listLoading = true;

				var parg = (0, _assign2.default)({}, row);

				_xstat2.default.removeRecord(parg).then(function (res) {
					_this2.listLoading = false;
					_this2.$notify({
						title: _AppText2.default.data.conf, type: 'success',
						message: _AppText2.default.getText("delOK", _this2.mainSubject, row[_this2.mainKey])
					});
					_this2.getRecords();
				});
			}).catch(function () {});
		},
		rowClass: function rowClass(row, index) {
			return "row";
		},

		handleEdit: function handleEdit(row) {
			this.editMode = "save";
			this.editTitle = _AppText2.default.getText("modM", this.mainSubject, row[this.mainKey]);
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.editMode = "add";
			this.editTitle = _AppText2.default.getText("addM", this.mainSubject);
			this.editFormVisible = true;
			this.editForm = {};
			this.editForm["statcode"] = this.code;
		},

		editSubmit: function editSubmit() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					_this3.editLoading = true;

					var parg = {};
					parg.Params = {};
					parg.Record = (0, _assign2.default)({}, _this3.editForm);

					if (_this3.editMode == "add") {
						_xstat2.default.addRecord(parg).then(function (res) {
							_AppUtil2.default.processMainResults(res);
							if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
								message: _AppText2.default.getText("addOK", _this3.mainSubject, _this3.editForm.showorder) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });
							_this3.$refs['editForm'].resetFields();
							_this3.editLoading = false;
							_this3.editFormVisible = false;
							_this3.getRecords();
						});
					} else {
						_xstat2.default.saveRecord(parg).then(function (res) {
							_AppUtil2.default.processMainResults(res);
							if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
								message: _AppText2.default.getText("modOK", _this3.mainSubject, _this3.editForm.showorder) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });
							_this3.$refs['editForm'].resetFields();
							_this3.editLoading = false;
							_this3.editFormVisible = false;
							_this3.getRecords();
						});
					}
				}
			});
		}

	},

	mounted: function mounted() {
		var _this4 = this;

		window.addEventListener("popstate", function (event) {
			_this4.closeForm();
		});

		if (this.$route.params) {
			this.stack = this.$route.params;
		}

		this.getRecords();
	}
};

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _dbccheck = __webpack_require__(304);

var _dbccheck2 = _interopRequireDefault(_dbccheck);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      QID: _AppUtil2.default.Initialize(this.$router, "DBCC"),
      util: _AppUtil2.default,
      stack: {},
      lang: _AppText2.default.data,
      codes: _AppUtil2.default.codes,

      editTitle: "",
      editMode: "",
      APICode: "DbcCheck",
      mainFunc: "DbcCheck",
      mainSubject: "file",
      mainKey: "date",
      mainKeyDesc: "date",
      content: [],

      traject: "RTM-HRG",
      booking: "82208232",
      departure: "2023-03-05",
      flightnum: "OR3423",
      allVersions: false,
      result: "",
      dbcdescs: {},
      dataLoading: false

    };
  },


  methods: {
    closeForm: function closeForm() {
      this.selectorVisible = false;
    },

    startCheck: function startCheck() {
      var _this = this;

      var parg = {};

      this.result = "";
      this.desc = {};
      parg.Params = {};
      parg.Params.booking = this.booking;
      parg.Params.departure = this.departure;
      parg.Params.flightnum = this.flightnum;
      parg.Params.traject = this.traject;
      parg.Params.allVersions = this.allVersions;

      this.dataLoading = true;
      _dbccheck2.default.execute('checkbooking', parg).then(function (res) {
        var d = res.data;
        _this.result = d.payload.dbccheck;
        _this.dbcdescs = d.payload.dbcdescs;
        _this.dataLoading = false;
      }).catch(function (error) {
        _AppUtil2.default.serverError(_this);
      });
    }

  },

  mounted: function mounted() {
    var _this2 = this;

    window.addEventListener("popstate", function (event) {
      _this2.closeForm();
    });

    if (this.$route.params) {
      this.stack = this.$route.params;
    }
  }
};

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _dbcload = __webpack_require__(305);

var _dbcload2 = _interopRequireDefault(_dbcload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      QID: _AppUtil2.default.Initialize(this.$router, "DBC"),
      util: _AppUtil2.default,
      stack: {},
      lang: _AppText2.default.data,
      codes: _AppUtil2.default.codes,
      pageSize: _AppSettings2.default.pageSize,
      serverPaging: false,

      editTitle: "",
      editMode: "",
      APICode: "DbcLoad",
      mainFunc: "DbcLoad",
      mainSubject: "file",
      mainKey: "date",
      mainKeyDesc: "date",
      searchFilter: '',
      content: [],
      counter: {},
      related: [],
      currentPage: 1,
      mainTotal: 0,
      marker: "",
      loadErrors: "",
      loadDossiers: "",
      currentTab: 'MAIN',
      dataLoading: false,

      listLoading: false,
      editFormVisible: false,
      editLoading: false,
      editForm: {},
      editFormRules: {
        anvrid: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
      }

    };
  },


  methods: {
    closeForm: function closeForm() {
      this.selectorVisible = false;
    },

    startSearch: function startSearch() {
      this.currentPage = 1;
      this.content = [];
      this.getRecords();
    },

    selectPagesize: function selectPagesize(size) {
      _AppSettings2.default.pageSize = size;
      this.showPagedData();
    },
    selectPage: function selectPage(page) {
      this.currentPage = page;
      this.showPagedData();
    },
    showPagedData: function showPagedData() {
      if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
    },

    getRecords: function getRecords() {
      var _this = this;

      var parg = {};
      parg.Params = {};
      parg.Params.search = this.searchFilter;

      this.listLoading = true;

      _dbcload2.default.getListPage(parg).then(function (res) {
        _AppUtil2.default.processMainResults(res);
        _this.codes = _AppUtil2.default.codes;
        _this.mainTotal = _AppUtil2.default.payload[_this.APICode].length;

        if (_this.mainTotal > 0) {
          if (_this.serverPaging) _this.content = _AppUtil2.default.getMainPayload(_this.APICode);else {
            _this.contentSaved = _AppUtil2.default.getMainPayload(_this.APICode);
            if (_this.contentSaved.length > 0) _this.selectPage(1);
          }
        } else {
          _this.content = [];
          _this.contentSaved = [];
        }
        _this.listLoading = false;
      }).catch(function (error) {
        _AppUtil2.default.serverError(_this);
      });
    },


    clickTab: function clickTab(tab, event) {
      if (this.currentTab == "ERRORS") this.openTabErrors("ERRORS");
      if (this.currentTab == "DOSSIERS") this.openTabDossiers("DOSSIERS");
    },

    openTabErrors: function openTabErrors(name) {
      var _this2 = this;

      var parg = {};
      parg.Params = {};
      parg.Params.marker = this.marker;

      this.dataLoading = true;
      _dbcload2.default.execute('errors', parg).then(function (res) {
        var d = res.data;

        _this2.loadErrors = d.payload.errors;
        _this2.dataLoading = false;
      }).catch(function (error) {
        _AppUtil2.default.serverError(_this2);
      });
    },
    openTabDossiers: function openTabDossiers(name) {
      var _this3 = this;

      var parg = {};
      parg.Params = {};
      parg.Params.marker = this.marker;

      this.dataLoading = true;
      _dbcload2.default.execute('dossiers', parg).then(function (res) {
        var d = res.data;

        _this3.loadDossiers = d.payload.dossiers;
        _this3.dataLoading = false;
      }).catch(function (error) {
        _AppUtil2.default.serverError(_this3);
      });
    },


    openRelated: function openRelated(row) {},

    handleDel: function handleDel(row) {
      var _this4 = this;

      this.$confirm(_AppText2.default.getText("sdelM", this.mainSubject, row[this.mainKeyDesc]), 'Confirm', {
        type: 'warning', title: _AppText2.default.getText("sdelT", this.mainSubject)
      }).then(function () {
        _this4.listLoading = true;

        var parg = {};
        parg.Record = row;

        _dbcload2.default.removeRecord(parg).then(function (res) {
          _this4.listLoading = false;
          _this4.$notify({
            title: _AppText2.default.data.conf, type: 'success',
            message: _AppText2.default.getText("delOK", _this4.mainSubject, row[_this4.mainKey])
          });
          _this4.getRecords();
        });
      }).catch(function () {});
    },

    handleView: function handleView(row) {
      this.editMode = "save";
      this.editTitle = _AppText2.default.getText("modM", this.mainSubject, row[this.mainKey]);
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)({}, row);

      this.marker = row.date;
      this.loaderrors = "";
      this.loadDossiers = "";
      this.currentTab = "MAIN";
    },

    handleAdd: function handleAdd() {
      this.editMode = "add";
      this.editTitle = _AppText2.default.getText("addM", this.mainSubject);
      this.editFormVisible = true;
      this.editForm = {};
    },

    editSubmit: function editSubmit() {
      var _this5 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this5.editLoading = true;

          var parg = {};
          parg.Params = {};
          parg.Record = (0, _assign2.default)({}, _this5.editForm);

          if (_this5.editMode == "add") {
            parg.Action = "add";
            _dbcload2.default.addRecord(parg).then(function (res) {
              if (res.data.header.OK) _this5.$notify({ title: _AppText2.default.data.done, type: 'success',
                message: _AppText2.default.getText("addOK", _this5.mainSubject, _this5.editForm.name) });else _this5.$notify({ title: "Error", type: 'error', message: res.data.header.message });
              _this5.$refs['editForm'].resetFields();
              _this5.editLoading = false;
              _this5.editFormVisible = false;
              _this5.getRecords();
            });
          } else {
            parg.Action = "save";
            _dbcload2.default.saveRecord(parg).then(function (res) {
              if (res.data.header.OK) _this5.$notify({ title: _AppText2.default.data.done, type: 'success',
                message: _AppText2.default.getText("modOK", _this5.mainSubject, _this5.editForm.name) });else _this5.$notify({ title: "Error", type: 'error', message: res.data.header.message });
              _this5.$refs['editForm'].resetFields();
              _this5.editLoading = false;
              _this5.editFormVisible = false;
              _this5.getRecords();
            });
          }
        }
      });
    }

  },

  mounted: function mounted() {
    var _this6 = this;

    window.addEventListener("popstate", function (event) {
      _this6.closeForm();
    });

    if (this.$route.params) {
      this.stack = this.$route.params;
    }

    this.related = _AppSettings2.default.getRelated();
    this.getRecords();
  }
};

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _xcode = __webpack_require__(306);

var _xcode2 = _interopRequireDefault(_xcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			QID: _AppUtil2.default.Initialize(this.$router, "XCD"),
			util: _AppUtil2.default,
			stack: {},
			lang: _AppText2.default.data,
			codes: _AppUtil2.default.codes,
			pageSize: _AppSettings2.default.pageSize,
			serverPaging: false,
			group: "detcode",
			editTitle: "",
			editMode: "",
			APICode: "XCode",
			mainFunc: "Xcode",
			mainSubject: "Xcode",
			mainKey: "code",
			mainKeyDesc: "code",
			searchFilter: '',
			content: [],
			counter: {},
			related: [],
			currentPage: 1,
			mainTotal: 0,

			listLoading: false,
			editFormVisible: false,
			editLoading: false,
			editForm: {},
			editFormRules: {
				code: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
			}

		};
	},


	methods: {
		closeForm: function closeForm() {
			this.selectorVisible = false;
			this.$router.push({ name: 'Employees', params: this.stack });
		},

		openGroup: function openGroup() {
			this.content = [];
			this.getRecords();
		},

		selectPagesize: function selectPagesize(size) {
			_AppSettings2.default.pageSize = size;
			this.showPagedData();
		},
		selectPage: function selectPage(page) {
			this.currentPage = page;
			this.showPagedData();
		},
		showPagedData: function showPagedData() {
			if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
		},

		getRecords: function getRecords() {
			var _this = this;

			var parg = {};
			parg.Params = {};
			parg.Params.group = this.group;

			window.sessionStorage.setItem("xcode.group", this.group);

			this.listLoading = true;

			_xcode2.default.getListPage(parg).then(function (res) {
				_AppUtil2.default.processMainResults(res);

				if (_this.codes) _this.codes = _AppUtil2.default.codes;

				if (_AppUtil2.default.getMainPayload(_this.APICode)) {
					_this.content = _AppUtil2.default.getMainPayload(_this.APICode);
					_this.mainTotal = _this.content.length;
				} else {
					_this.content = [];
					_this.contentSaved = [];
				}
				_this.listLoading = false;
			}).catch(function (error) {
				_AppUtil2.default.serverError(_this);
			});
		},


		openRelated: function openRelated(row) {},

		handleDel: function handleDel(row) {
			var _this2 = this;

			this.$confirm(_AppText2.default.getText("sdelM", this.mainSubject, row[this.mainKeyDesc]), 'Confirm', {
				type: 'warning', title: _AppText2.default.getText("sdelT", this.mainSubject)
			}).then(function () {
				_this2.listLoading = true;

				var parg = (0, _assign2.default)({}, row);

				_xcode2.default.removeRecord(parg).then(function (res) {
					_this2.listLoading = false;
					_this2.$notify({
						title: _AppText2.default.data.conf, type: 'success',
						message: _AppText2.default.getText("delOK", _this2.mainSubject, row[_this2.mainKey])
					});
					_this2.getRecords();
				});
			}).catch(function () {});
		},

		handleEdit: function handleEdit(row) {
			this.editMode = "save";
			this.editTitle = _AppText2.default.getText("modM", this.mainSubject, row[this.mainKey]);
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.editMode = "add";
			this.editTitle = _AppText2.default.getText("addM", this.mainSubject);
			this.editFormVisible = true;
			this.editForm = {};
			this.editForm["groupname"] = this.group;
		},

		editSubmit: function editSubmit() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					_this3.editLoading = true;

					var parg = {};
					parg.Params = {};
					parg.Record = (0, _assign2.default)({}, _this3.editForm);

					if (_this3.editMode == "add") {
						_xcode2.default.addRecord(parg).then(function (res) {
							_AppUtil2.default.processMainResults(res);
							if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
								message: _AppText2.default.getText("addOK", _this3.mainSubject, _this3.editForm.showorder) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });
							_this3.$refs['editForm'].resetFields();
							_this3.editLoading = false;
							_this3.editFormVisible = false;
							_this3.getRecords();
						});
					} else {
						_xcode2.default.saveRecord(parg).then(function (res) {
							_AppUtil2.default.processMainResults(res);
							if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
								message: _AppText2.default.getText("modOK", _this3.mainSubject, _this3.editForm.showorder) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });
							_this3.$refs['editForm'].resetFields();
							_this3.editLoading = false;
							_this3.editFormVisible = false;
							_this3.getRecords();
						});
					}
				}
			});
		}

	},

	mounted: function mounted() {
		var _this4 = this;

		window.addEventListener("popstate", function (event) {
			_this4.closeForm();
		});

		if (this.$route.params) {
			this.stack = this.$route.params;
		}

		if (window.sessionStorage.getItem("xcode.group")) this.group = window.sessionStorage.getItem("xcode.group");

		this.related = _AppSettings2.default.getRelated();
		this.getRecords();
	}
};

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _xdata = __webpack_require__(307);

var _xdata2 = _interopRequireDefault(_xdata);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			QID: _AppUtil2.default.Initialize(this.$router, "XD"),
			util: _AppUtil2.default,
			stack: {},
			lang: _AppText2.default.data,
			codes: _AppUtil2.default.codes,
			pageSize: _AppSettings2.default.pageSize,
			serverPaging: false,

			editTitle: "",
			editMode: "",
			APICode: "XData",
			mainFunc: "Snippet",
			mainSubject: "Snippet",
			mainKey: "code",
			mainKeyDesc: "title",
			searchFilter: '',
			userdept: "",
			content: [],
			counter: {},
			related: [],
			currentPage: 1,
			mainTotal: 0,

			listLoading: false,
			editFormVisible: false,
			editLoading: false,
			editForm: {},
			editFormRules: {
				xdatacode: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
			}

		};
	},


	methods: {

		startSearch: function startSearch() {
			this.currentPage = 1;
			this.content = [];
			this.getRecords();
		},

		selectPagesize: function selectPagesize(size) {
			_AppSettings2.default.pageSize = size;
			this.showPagedData();
		},
		selectPage: function selectPage(page) {
			this.currentPage = page;
			this.showPagedData();
		},
		showPagedData: function showPagedData() {
			if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
		},

		getRecords: function getRecords() {
			var _this = this;

			var parg = {};
			parg.Params = {};
			parg.Params.search = this.searchFilter;

			this.listLoading = true;

			_xdata2.default.getListPage(parg).then(function (res) {

				_AppUtil2.default.processMainResults(res);
				_this.codes = _AppUtil2.default.codes;
				_this.mainTotal = _AppUtil2.default.payload[_this.APICode].length;
				_this.userdept = _AppUtil2.default.header["udepts"];
				if (_this.mainTotal > 0) {
					if (_this.serverPaging) _this.content = _AppUtil2.default.getMainPayload(_this.APICode);else {
						_this.contentSaved = _AppUtil2.default.getMainPayload(_this.APICode);
						if (_this.contentSaved.length > 0) _this.selectPage(1);
					}
				} else {
					_this.content = [];
					_this.contentSaved = [];
				}
				_this.listLoading = false;
			}).catch(function (error) {
				_AppUtil2.default.serverError(_this);
			});
		},


		openRelated: function openRelated(row) {},

		handleDel: function handleDel(row) {
			var _this2 = this;

			this.$confirm(_AppText2.default.getText("sdelM", this.mainSubject, row[this.mainKeyDesc]), 'Confirm', {
				type: 'warning', title: _AppText2.default.getText("sdelT", this.mainSubject)
			}).then(function () {
				_this2.listLoading = true;

				var parg = {};
				parg.Params = {};
				parg.Record = (0, _assign2.default)({}, row);

				_xdata2.default.removeRecord(parg).then(function (res) {
					_AppUtil2.default.processMainResults(res);
					_this2.listLoading = false;
					_this2.$notify({
						title: _AppText2.default.data.conf, type: 'success',
						message: _AppText2.default.getText("delOK", _this2.mainSubject, row[_this2.mainKeyDesc])
					});
					_this2.getRecords();
				});
			}).catch(function () {});
		},

		handleEdit: function handleEdit(row) {
			this.editMode = "save";
			this.editTitle = _AppText2.default.getText("modM", this.mainSubject, row[this.mainKeyDesc]);
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.editMode = "add";
			this.editTitle = _AppText2.default.getText("addM", this.mainSubject);
			this.editFormVisible = true;
			this.editForm = {};
		},

		editSubmit: function editSubmit() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					_this3.editLoading = true;

					var parg = {};
					parg.Params = {};
					parg.Record = (0, _assign2.default)({}, _this3.editForm);

					if (_this3.editMode == "add") {
						_xdata2.default.addRecord(parg).then(function (res) {
							_AppUtil2.default.processMainResults(res);
							if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
								message: _AppText2.default.getText("addOK", _this3.mainSubject, _this3.editForm.xdatacode) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });

							_this3.editLoading = false;
							_this3.editFormVisible = false;
							_this3.getRecords();
						});
					} else {
						_xdata2.default.saveRecord(parg).then(function (res) {
							_AppUtil2.default.processMainResults(res);
							if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
								message: _AppText2.default.getText("modOK", _this3.mainSubject, _this3.editForm.xdatacode) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });

							_this3.editLoading = false;
							_this3.editFormVisible = false;
							_this3.getRecords();
						});
					}
				}
			});
		}

	},

	mounted: function mounted() {
		var _this4 = this;

		window.onresize = this.reportWindowSize;
		this.reportWindowSize;

		window.addEventListener("popstate", function (event) {
			_this4.closeForm();
		});

		this.listLoading = true;
		this.getRecords();
	}
};

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _xlog = __webpack_require__(308);

var _xlog2 = _interopRequireDefault(_xlog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			QID: _AppUtil2.default.Initialize(this.$router, "XLG"),
			util: _AppUtil2.default,
			stack: {},
			lang: _AppText2.default.data,
			codes: _AppUtil2.default.codes,
			pageSize: _AppSettings2.default.pageSize,
			serverPaging: false,
			group: "",
			editTitle: "",
			editMode: "",
			APICode: "XLog",
			mainFunc: "XLog",
			mainSubject: "log",
			mainKey: "name",
			mainKeyDesc: "name",
			searchFilter: '',

			content: [],
			text: "",
			currentPage: 1,
			mainTotal: 0,

			listLoading: false,
			editFormVisible: false,
			editLoading: false,
			editForm: {},
			editFormRules: {
				code: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
			}

		};
	},


	methods: {
		closeForm: function closeForm() {
			this.selectorVisible = false;
			this.$router.push({ name: 'Employees', params: this.stack });
		},

		openGroup: function openGroup() {
			this.content = [];
			this.getRecords();
		},

		selectPagesize: function selectPagesize(size) {
			_AppSettings2.default.pageSize = size;
			this.showPagedData();
		},
		selectPage: function selectPage(page) {
			this.currentPage = page;
			this.showPagedData();
		},
		showPagedData: function showPagedData() {
			if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
		},

		getRecords: function getRecords() {
			var _this = this;

			var parg = {};
			parg.Params = {};

			this.listLoading = true;

			_xlog2.default.execute("list", parg).then(function (res) {
				_AppUtil2.default.processMainResults(res);

				if (_AppUtil2.default.getMainPayload("logs")) {
					_this.content = _AppUtil2.default.getMainPayload("logs");
					_this.mainTotal = _this.content.length;
				}
				_this.listLoading = false;
			}).catch(function (error) {
				_AppUtil2.default.serverError(_this);
			});
		},
		getContent: function getContent(file) {
			var _this2 = this;

			var parg = {};
			parg.Params = {};
			parg.Params.file = file;

			this.listLoading = true;

			_xlog2.default.execute("view", parg).then(function (res) {
				_this2.text = res.data.payload.content;
				_this2.listLoading = false;
			}).catch(function (error) {
				_AppUtil2.default.serverError(_this2);
			});
		},

		handleDel: function handleDel(row) {
			var _this3 = this;

			this.$confirm(_AppText2.default.getText("sdelM", this.mainSubject, row[this.mainKeyDesc]), 'Confirm', {
				type: 'warning', title: _AppText2.default.getText("sdelT", this.mainSubject)
			}).then(function () {
				var parg = {};
				parg.Params = {};
				parg.Params.file = row.name;

				_this3.listLoading = true;

				_xlog2.default.execute("del", parg).then(function (res) {
					_this3.listLoading = false;
					_this3.getRecords();
				}).catch(function (error) {
					_AppUtil2.default.serverError(_this3);
				});
			}).catch(function () {});
		},

		handleView: function handleView(row) {
			this.editMode = "view";
			this.editTitle = _AppText2.default.getText("modM", this.mainSubject, row[this.mainKey]);
			this.editFormVisible = true;
			this.getContent(row.name);

			this.editForm = (0, _assign2.default)({}, row);
		}

	},

	mounted: function mounted() {
		var _this4 = this;

		window.addEventListener("popstate", function (event) {
			_this4.closeForm();
		});

		if (this.$route.params) {
			this.stack = this.$route.params;
		}

		this.getRecords();
	}
};

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _xnews = __webpack_require__(309);

var _xnews2 = _interopRequireDefault(_xnews);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			QID: _AppUtil2.default.Initialize(this.$router, "XN"),
			util: _AppUtil2.default,
			stack: {},
			lang: _AppText2.default.data,
			codes: _AppUtil2.default.codes,
			pageSize: _AppSettings2.default.pageSize,
			serverPaging: false,

			editTitle: "",
			editMode: "",
			APICode: "XNews",
			mainFunc: "XNews",
			mainSubject: "XNews",
			mainKey: "newskey",
			mainKeyDesc: "newskey",
			searchFilter: '',
			content: [],
			counter: {},
			related: [],
			currentPage: 1,
			mainTotal: 0,

			listLoading: false,
			editFormVisible: false,
			editLoading: false,
			editForm: {},
			editFormRules: {
				xnewscode: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
			}

		};
	},


	methods: {

		startSearch: function startSearch() {
			this.currentPage = 1;
			this.content = [];
			this.getRecords();
		},

		selectPagesize: function selectPagesize(size) {
			_AppSettings2.default.pageSize = size;
			this.showPagedData();
		},
		selectPage: function selectPage(page) {
			this.currentPage = page;
			this.showPagedData();
		},
		showPagedData: function showPagedData() {
			if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
		},

		getRecords: function getRecords() {
			var _this = this;

			var parg = {};
			parg.Params = {};
			parg.Params.search = this.searchFilter;

			this.listLoading = true;

			_xnews2.default.getListPage(parg).then(function (res) {

				_AppUtil2.default.processMainResults(res);
				_this.codes = _AppUtil2.default.codes;
				_this.mainTotal = _AppUtil2.default.payload[_this.APICode].length;

				if (_this.mainTotal > 0) {
					if (_this.serverPaging) _this.content = _AppUtil2.default.getMainPayload(_this.APICode);else {
						_this.contentSaved = _AppUtil2.default.getMainPayload(_this.APICode);
						if (_this.contentSaved.length > 0) _this.selectPage(1);
					}
				} else {
					_this.content = [];
					_this.contentSaved = [];
				}
				_this.listLoading = false;
			}).catch(function (error) {
				_AppUtil2.default.serverError(_this);
			});
		},


		openRelated: function openRelated(row) {},

		handleDel: function handleDel(row) {
			var _this2 = this;

			this.$confirm(_AppText2.default.getText("sdelM", this.mainSubject, row[this.mainKeyDesc]), 'Confirm', {
				type: 'warning', title: _AppText2.default.getText("sdelT", this.mainSubject)
			}).then(function () {
				_this2.listLoading = true;

				var parg = {};
				parg.Params = {};
				parg.Record = (0, _assign2.default)({}, row);

				_xnews2.default.removeRecord(parg).then(function (res) {
					_AppUtil2.default.processMainResults(res);
					_this2.listLoading = false;
					_this2.$notify({
						title: _AppText2.default.data.conf, type: 'success',
						message: _AppText2.default.getText("delOK", _this2.mainSubject, row[_this2.mainKeyDesc])
					});
					_this2.getRecords();
				});
			}).catch(function () {});
		},

		handleEdit: function handleEdit(row) {
			this.editMode = "save";
			this.editTitle = _AppText2.default.getText("modM", this.mainSubject, row[this.mainKeyDesc]);
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.editMode = "add";
			this.editTitle = _AppText2.default.getText("addM", this.mainSubject);
			this.editFormVisible = true;
			this.editForm = {};
		},

		editSubmit: function editSubmit() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					_this3.editLoading = true;

					var parg = {};
					parg.Params = {};
					parg.Record = (0, _assign2.default)({}, _this3.editForm);

					if (_this3.editMode == "add") {
						_xnews2.default.addRecord(parg).then(function (res) {
							_AppUtil2.default.processMainResults(res);
							if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
								message: _AppText2.default.getText("addOK", _this3.mainSubject, _this3.editForm.xnewscode) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });

							_this3.editLoading = false;
							_this3.editFormVisible = false;
							_this3.getRecords();
						});
					} else {
						_xnews2.default.saveRecord(parg).then(function (res) {
							_AppUtil2.default.processMainResults(res);
							if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
								message: _AppText2.default.getText("modOK", _this3.mainSubject, _this3.editForm.xnewscode) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });

							_this3.editLoading = false;
							_this3.editFormVisible = false;
							_this3.getRecords();
						});
					}
				}
			});
		}

	},

	mounted: function mounted() {
		var _this4 = this;

		window.onresize = this.reportWindowSize;
		this.reportWindowSize;

		window.addEventListener("popstate", function (event) {
			_this4.closeForm();
		});

		this.listLoading = true;
		this.getRecords();
	}
};

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__(76);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _xprofile = __webpack_require__(310);

var _xprofile2 = _interopRequireDefault(_xprofile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		var _ref;

		return _ref = {
			QID: _AppUtil2.default.Initialize(this.$router, "XP"),
			util: _AppUtil2.default,
			stack: {},
			lang: _AppText2.default.data,
			codes: _AppUtil2.default.codes,


			APICode: "XUser",
			payload: []
		}, (0, _defineProperty3.default)(_ref, 'codes', []), (0, _defineProperty3.default)(_ref, 'header', []), (0, _defineProperty3.default)(_ref, 'mainForm', {}), (0, _defineProperty3.default)(_ref, 'mainLoading', false), (0, _defineProperty3.default)(_ref, 'curIcon', ""), (0, _defineProperty3.default)(_ref, 'mainFormRules', {}), _ref;
	},

	methods: {
		getRecords: function getRecords() {
			var _this = this;

			var parg = {};
			this.mainLoading = true;

			_xprofile2.default.getProfile(parg).then(function (res) {
				_AppUtil2.default.processMainResults(res);
				_this.codes = _AppUtil2.default.codes;
				_this.mainTotal = _AppUtil2.default.getMainHeader("total_" + _this.APICode);
				_this.mainForm = _AppUtil2.default.getMainPayload(_this.APICode);
				_this.MainFormVisible = true;

				if (_this.codes.Img) {
					_this.codes.Img.forEach(function (item) {
						item.IconUrl = "./static/" + item.Url;
					});
				};

				_this.curIcon = "./static/" + _this.mainForm.useravatar;
				_this.mainLoading = false;
			}).catch(function (error) {
				_AppUtil2.default.serverError(_this);
			});
		},


		showChanged: function showChanged() {
			this.curIcon = "./static/" + this.mainForm.useravatar;
		},

		mainSubmit: function mainSubmit() {
			var _this2 = this;

			if (this.mainForm['password']) {
				var isSame = this.mainForm.password == this.mainForm.password2;
				if (isSame == false) {
					this.$message({
						message: 'Passwords are not the same!!',
						type: 'error'
					});
					return;
				}
			}


			this.mainLoading = true;

			var parg = {};
			parg.Params = {};
			parg.Record = (0, _assign2.default)({}, this.mainForm);
			this.curIcon = "./static/" + this.mainForm.useravatar;

			_xprofile2.default.saveProfile(parg).then(function (res) {
				_this2.mainLoading = false;
				_this2.$notify({
					title: "Profile saved",
					message: "Your profile has been updated, any changes will be visible on next login.",
					type: 'success'
				});
				_this2.$router.push({ path: '/' });
			});
		}
	},

	mounted: function mounted() {
		this.getRecords();
	}
};

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
		value: true
});

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _xshownews = __webpack_require__(167);

var _xshownews2 = _interopRequireDefault(_xshownews);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
		data: function data() {
				return {
						QID: _AppUtil2.default.Initialize(this.$router, "XL"),
						util: _AppUtil2.default,
						stack: {},
						lang: _AppText2.default.data,
						pageSize: _AppSettings2.default.pageSize,
						serverPaging: false,

						APICode: "XNews",
						content: [],
						counter: {},
						currentPage: 1,
						mainTotal: 0,

						listLoading: false,
						xeditFormVisible: false,
						xeditLoading: false,
						xeditForm: {}
				};
		},


		methods: {
				bodystyle: function bodystyle(hot) {
						if (hot) return "background-color:#eaf3ff;x:rgb(234 243 255);";else return "";
				},

				xstartSearch: function xstartSearch() {
						this.currentPage = 1;
						this.content = [];
						this.getRecords();
				},

				selectPagesize: function selectPagesize(size) {
						_AppSettings2.default.pageSize = size;
						this.showPagedData();
				},
				selectPage: function selectPage(page) {
						this.currentPage = page;
						this.showPagedData();
				},
				showPagedData: function showPagedData() {
						if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
				},

				getRecords: function getRecords() {
						var _this = this;

						var parg = {};

						this.listLoading = true;

						_xshownews2.default.getNews(parg).then(function (res) {
								_AppUtil2.default.processMainResults(res);
								_this.codes = _AppUtil2.default.codes;
								_this.mainTotal = _AppUtil2.default.payload[_this.APICode].length;
								if (_this.mainTotal > 0) {
										if (_this.serverPaging) _this.content = _AppUtil2.default.getMainPayload(_this.APICode);else {
												_this.contentSaved = _AppUtil2.default.getMainPayload(_this.APICode);
												if (_this.contentSaved.length > 0) _this.selectPage(1);
										}
								} else {
										_this.content = [];
										_this.contentSaved = [];
								}
								_this.listLoading = false;
						}).catch(function (error) {
								_AppUtil2.default.serverError(_this);
						});
				}
		},

		mounted: function mounted() {
				this.related = _AppSettings2.default.getRelated();
				this.getRecords();
		}
};

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _AppSettings = __webpack_require__(9);

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _AppText = __webpack_require__(10);

var _AppText2 = _interopRequireDefault(_AppText);

var _xuser = __webpack_require__(311);

var _xuser2 = _interopRequireDefault(_xuser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      QID: _AppUtil2.default.Initialize(this.$router, "XU"),
      stageList: ["PRD", "DEV", "ITG", "QUA"],
      util: _AppUtil2.default,
      stack: {},
      lang: _AppText2.default.data,
      codes: _AppUtil2.default.codes,
      pageSize: _AppSettings2.default.pageSize,
      serverPaging: false,

      uroles: [],
      udepts: [],
      ustages: [],
      APICode: "XUser",
      editTitle: "",
      editMode: "",
      mainFunc: "Users",
      mainSubject: "User",
      mainKey: "usercode",
      mainKeyDesc: "username",
      searchFilter: '',

      curIcon: '',
      content: [],
      contentSaved: [],
      counter: {},
      parent: [],
      related: [],
      currentPage: 1,
      mainTotal: 0,

      werk: "",
      listLoading: false,
      editFormVisible: false,
      editLoading: false,
      editForm: {},
      editFormRules: {
        usercode: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }],
        username: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }],
        useremail: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }],
        userlevel: [{ required: true, message: _AppText2.default.data.mandatory, trigger: 'blur' }]
      }

    };
  },


  methods: {

    startSearch: function startSearch() {
      this.currentPage = 1;
      this.content = [];
      this.getRecords();
    },

    selectPagesize: function selectPagesize(size) {
      _AppSettings2.default.pageSize = size;
      this.showPagedData();
    },
    selectPage: function selectPage(page) {
      this.currentPage = page;
      this.showPagedData();
    },
    showPagedData: function showPagedData() {
      if (this.serverPaging) this.getRecords();else this.content = this.contentSaved.slice((this.currentPage - 1) * _AppSettings2.default.pageSize, this.currentPage * _AppSettings2.default.pageSize);
    },

    getRecords: function getRecords() {
      var _this = this;

      var parg = {};
      parg.Params = {};
      parg.Params["search"] = this.searchFilter;

      if (this.serverPaging) {
        parg.Params["_page"] = this.currentPage;
        parg.Params["_psize"] = _AppSettings2.default.pageSize;
      }

      this.listLoading = true;

      _xuser2.default.getListPage(parg).then(function (res) {
        _AppUtil2.default.processMainResults(res);
        _this.codes = _AppUtil2.default.codes;
        _this.mainTotal = _AppUtil2.default.payload[_this.APICode].length;
        if (_this.mainTotal > 0) {
          if (_this.serverPaging) _this.content = _AppUtil2.default.getMainPayload(_this.APICode);else {
            _this.contentSaved = _AppUtil2.default.getMainPayload(_this.APICode);
            if (_this.contentSaved.length > 0) _this.selectPage(1);
          }
        } else {
          _this.content = [];
          _this.contentSaved = [];
        }
        _this.listLoading = false;
      }).catch(function (error) {
        _AppUtil2.default.serverError(_this);
      });

      this.listLoading = false;
    },


    showChanged: function showChanged() {
      if (this.editForm.useravatar) {
        this.curIcon = "./static/" + this.editForm.useravatar;
      }
    },

    openApps: function openApps(row) {
      this.stack["user"] = row.usercode;
      this.$router.push({ name: 'User Application Access', params: this.stack });
    },

    openRelated: function openRelated(row) {},

    handleDel: function handleDel(row) {
      var _this2 = this;

      this.$confirm(_AppText2.default.getText("sdelM", this.mainSubject, row[this.mainKeyDesc]), 'Confirm', {
        type: 'warning', title: _AppText2.default.getText("sdelT", this.mainSubject)
      }).then(function () {
        _this2.listLoading = true;

        var parg = {};
        parg.Record = row;

        _xuser2.default.removeRecord(parg).then(function (res) {
          _AppUtil2.default.processMainResults(res);
          _this2.listLoading = false;
          _this2.$notify({
            title: _AppText2.default.data.conf, type: 'success',
            message: _AppText2.default.getText("delOK", _this2.mainSubject, row[_this2.mainKeyDesc])
          });
          _this2.startSearch();
        });
      }).catch(function () {});
    },

    handleEdit: function handleEdit(row) {
      this.editMode = "save";
      this.editTitle = _AppText2.default.getText("modM", this.mainSubject, row[this.mainKeyDesc]);
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)({}, row);
      this.uroles = [];
      this.udepts = [];
      this.ustages = [];
      if (this.editForm['userroles'] != "") this.uroles = this.editForm["userroles"].split(' ');
      if (this.editForm['departments'] != "") this.udepts = this.editForm["departments"].split(' ');
      if (this.editForm["stages"]) this.ustages = this.editForm["stages"].split(' ');
      {}

      this.showChanged();
    },

    handleAdd: function handleAdd() {
      this.editMode = "add";
      this.editTitle = _AppText2.default.getText("addM", this.mainSubject);
      this.editFormVisible = true;
      this.editForm = {};
      this.uroles = ["user"];
      this.udepts = [];
    },

    editSubmit: function editSubmit() {
      var _this3 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this3.editLoading = true;

          var parg = {};
          parg.Params = {};
          parg.Record = _this3.editForm;
          parg.Record["userroles"] = _this3.uroles.join(' ');
          parg.Record["departments"] = _this3.udepts.join(' ');
          parg.Record["stages"] = _this3.ustages.join(' ');

          if (_this3.editMode == "add") {
            _xuser2.default.addRecord(parg).then(function (res) {
              _AppUtil2.default.processMainResults(res);
              if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
                message: _AppText2.default.getText("addOK", _this3.mainSubject, _this3.editForm.usercode) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });
              _this3.$refs['editForm'].resetFields();
              _this3.editLoading = false;
              _this3.editFormVisible = false;
              _this3.getRecords();
            });
          } else {
            _xuser2.default.saveRecord(parg).then(function (res) {
              _AppUtil2.default.processMainResults(res);
              if (_AppUtil2.default.header.OK) _this3.$notify({ title: _AppText2.default.data.done, type: 'success',
                message: _AppText2.default.getText("modOK", _this3.mainSubject, _this3.editForm.usercode) });else _this3.$notify({ title: "Error", type: 'error', message: _AppUtil2.default.header.message });
              _this3.$refs['editForm'].resetFields();
              _this3.editLoading = false;
              _this3.editFormVisible = false;
              _this3.getRecords();
            });
          }
        }
      });
    }
  },

  mounted: function mounted() {
    if (this.$route.params) this.stack = this.$route.params;

    this.getRecords();
  }
};

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 1;
var ApiCode = "anvr";

exports.default = {

  execute: function execute(action, params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, action);
  },

  getListPage: function getListPage(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "list");
  },

  removeRecord: function removeRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "del");
  },

  addRecord: function addRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "add");
  },

  saveRecord: function saveRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "save");
  },

  getRecord: function getRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "get");
  }
};

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 1;
var ApiCode = "Maintenance";

exports.default = {

  execute: function execute(action, params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, action);
  }
};

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 2;
var ApiCode = "report";

exports.default = {

  execute: function execute(action, params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, action);
  }
};

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 1;
var ApiCode = "site";

exports.default = {

  execute: function execute(action, params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, action);
  },

  getListPage: function getListPage(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "list");
  },

  removeRecord: function removeRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "del");
  },

  addRecord: function addRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "add");
  },

  saveRecord: function saveRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "save");
  },

  getRecord: function getRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "get");
  }
};

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 1;
var ApiCode = "BasSupplier";

exports.default = {

  execute: function execute(action, params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, action);
  },

  getListPage: function getListPage(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "list");
  },

  removeRecord: function removeRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "del");
  },

  addRecord: function addRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "add");
  },

  saveRecord: function saveRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "save");
  },

  getRecord: function getRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "get");
  }
};

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 1;
var ApiCode = "view";

exports.default = {

  execute: function execute(action, params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, action);
  },

  getListPage: function getListPage(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "list");
  },

  removeRecord: function removeRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "del");
  },

  addRecord: function addRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "add");
  },

  saveRecord: function saveRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "save");
  },

  getRecord: function getRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "get");
  }
};

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 3;
var ApiCode = "dbccheck";

exports.default = {

  execute: function execute(action, params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, action);
  }
};

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 3;
var ApiCode = "dbcload";

exports.default = {

  execute: function execute(action, params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, action);
  },

  getListPage: function getListPage(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "list");
  },

  removeRecord: function removeRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "del");
  },

  addRecord: function addRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "add");
  },

  saveRecord: function saveRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "save");
  },

  getRecord: function getRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "get");
  }
};

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 0;
var ApiCode = "XCode";

exports.default = {
  getListPage: function getListPage(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "list");
  },

  removeRecord: function removeRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "del");
  },

  addRecord: function addRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "add");
  },

  saveRecord: function saveRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "save");
  },

  getRecord: function getRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "get");
  }
};

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 0;
var ApiCode = "XData";

exports.default = {
  getListPage: function getListPage(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "list");
  },

  removeRecord: function removeRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "del");
  },

  addRecord: function addRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "add");
  },

  saveRecord: function saveRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "save");
  },

  getRecord: function getRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "get");
  }
};

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 0;
var ApiCode = "XLog";

exports.default = {

  execute: function execute(action, params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, action);
  }
};

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 0;
var ApiCode = "XNews";

exports.default = {
  getListPage: function getListPage(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "list");
  },

  removeRecord: function removeRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "del");
  },

  addRecord: function addRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "add");
  },

  saveRecord: function saveRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "save");
  },

  getRecord: function getRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "get");
  }
};

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 0;
var ApiCode = "XUser";

exports.default = {
  getProfile: function getProfile(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "userread");
  },
  saveProfile: function saveProfile(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "usersave");
  }

};

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerMode = 0;
var ApiCode = "xuser";

exports.default = {
  getListPage: function getListPage(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "list");
  },

  removeRecord: function removeRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "del");
  },

  addRecord: function addRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "add");
  },

  saveRecord: function saveRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "save");
  },

  getRecord: function getRecord(params) {
    return _AppUtil2.default.callServerPost(ServerMode, ApiCode, params, "get");
  }
};

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(227);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(231);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(154);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(229);

var _vueRouter = __webpack_require__(232);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _routes = __webpack_require__(226);

var _routes2 = _interopRequireDefault(_routes);

var _AppUtil = __webpack_require__(1);

var _AppUtil2 = _interopRequireDefault(_AppUtil);

var _axios = __webpack_require__(153);

var _axios2 = _interopRequireDefault(_axios);

var _vueGoogleCharts = __webpack_require__(230);

var _vueGoogleCharts2 = _interopRequireDefault(_vueGoogleCharts);

var _vueWysiwyg = __webpack_require__(233);

var _vueWysiwyg2 = _interopRequireDefault(_vueWysiwyg);

__webpack_require__(228);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueWysiwyg2.default, {
  hideModules: { "code": true, "table": true },
  maxHeight: "150px"
});

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueGoogleCharts2.default);

var router = new _vueRouter2.default({
  routes: _routes2.default
});

router.beforeEach(function (to, from, next) {

  if (to.path == '/login') {
    window.sessionStorage.removeItem('token');
    window.sessionStorage.removeItem('user');
  }

  var user = window.sessionStorage.getItem('token');
  if (!user && to.path != '/login' && to.path != '/changepassword') {
    next({ path: '/login' });
  } else {
    next();
  }
});

var app = new _vue2.default({
  router: router,
  created: function created() {},
  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 577:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 578:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 590:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-261-213.d0bf694.jpg";

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tuilogo.5b88591.png";

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(569)

var Component = __webpack_require__(6)(
  /* script */
  null,
  /* template */
  __webpack_require__(631),
  /* scopeId */
  "data-v-08d8a476",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(580)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(642),
  /* scopeId */
  "data-v-58775a8e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(568)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(630),
  /* scopeId */
  "data-v-0566967c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(585)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(647),
  /* scopeId */
  "data-v-6ba26bd4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(572)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(634),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(571)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(633),
  /* scopeId */
  "data-v-15c9733c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(586)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(648),
  /* scopeId */
  "data-v-70a3e4ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(593)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(655),
  /* scopeId */
  "data-v-fb37d650",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(578)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(640),
  /* scopeId */
  "data-v-3a3de56d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(577)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  "data-v-2de8a2a0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(579)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(641),
  /* scopeId */
  "data-v-3f8a9a37",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(588)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  "data-v-9c4dfcec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(573)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(635),
  /* scopeId */
  "data-v-19e4c40f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(582)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(644),
  /* scopeId */
  "data-v-5e3d0430",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(590)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(652),
  /* scopeId */
  "data-v-c9a5105a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(587)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  "data-v-7a4f7199",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(584)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(646),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(591)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(653),
  /* scopeId */
  "data-v-f75606a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(592)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(654),
  /* scopeId */
  "data-v-fb0cef70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(574)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(636),
  /* scopeId */
  "data-v-20d8a385",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(581)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(643),
  /* scopeId */
  "data-v-5c3ed939",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(570)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(632),
  /* scopeId */
  "data-v-0959822e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(583)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(645),
  /* scopeId */
  "data-v-61a7e2c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(575)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(637),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(589)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(651),
  /* scopeId */
  "data-v-b358b1b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [(_vm.showMiniMenu || !_vm.collapsed) ? _c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width' + ' ' + _vm.stageClass,
    attrs: {
      "span": 10,
      "title": _vm.versionInfo(),
      "i": ""
    }
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-10px",
      "height": "35px",
      "width": "35px",
      "border-radius": "2px"
    },
    attrs: {
      "src": __webpack_require__(604)
    }
  }), _vm._v(" "), _vm._v("\n\t\t\t\t" + _vm._s(_vm.collapsed ? '' : "Tui-WRD-Services" + this.stageSubtitle) + "\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "tools",
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "xclick.prevent": "collapse"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "-10px",
      "margin-top": "2px",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-menu",
    staticStyle: {
      "font-size": "20px"
    }
  })])])])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": this.sysUserAvatar
    }
  }), _vm._v(" " + _vm._s(this.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.openPage('/shownews')
      }
    }
  }, [_vm._v("News")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.openPage('/profile')
      }
    }
  }, [_vm._v("Profile")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("Logout")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [(_vm.showMiniMenu || !_vm.collapsed) ? _c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded',
    attrs: {
      "id": "sidemenu"
    }
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_c('el-menu-item', {
    staticClass: "topitem",
    attrs: {
      "index": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openPage('/main')
      }
    }
  }, [_c('li', {
    staticClass: "el-icon-s-home"
  }), _vm._v(" Home\n          ")]), _vm._v(" "), _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden && _vm.canUse(item)) ? [(!item.leaf && _vm.canUse(item)) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name) + "\n              ")]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden && _vm.canUse(child)) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name) + "\n              ")]) : _vm._e()
    })], 2) : _vm._e()] : _vm._e()
  }), _vm._v(" "), _c('el-menu-item', {
    staticClass: "topitem",
    attrs: {
      "index": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openPage('/shownews')
      }
    }
  }, [_c('li', {
    staticClass: "el-icon-info"
  }), _vm._v(" News & Messages")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "topitem",
    attrs: {
      "index": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_c('li', {
    staticClass: "el-icon-platform-eleme"
  }), _vm._v(" Logout")])], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf && _vm.canUse(item)) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden && _vm.canUse(child)) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "10px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" " + _vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 631:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 >> Deze pagina bestaat niet (meer)")])
},staticRenderFns: []}

/***/ }),

/***/ 632:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.startSearch.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v(_vm._s(_vm.lang.butSearch))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.searchFilter = '';
        _vm.getRecords();
      }
    }
  }, [_vm._v("C")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.lang.butAdd))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "newscreated",
      "label": "Created",
      "min-width": "129",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "newstitle",
      "label": "Title",
      "min-width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "newsby",
      "label": "By",
      "min-width": "80",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "Size",
      "min-width": "60",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t" + _vm._s(scope.row.newstext ? scope.row.newstext.length : 0) + " bytes\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "xdisabled": "allowed[0]==false",
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "current-page": _vm.currentPage,
      "page-sizes": [10, 15, 25, 50, 100, 1000],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" News")]), _vm._v(" "), (this.editMode == 'save') ? _c('el-form-item', {
    attrs: {
      "label": "ID :",
      "prop": "id"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['newskey']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'newskey', $$v)
      },
      expression: "editForm['newskey']"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['newscreated']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'newscreated', $$v)
      },
      expression: "editForm['newscreated']"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Title :",
      "prop": "newstitle"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['newstitle']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'newstitle', $$v)
      },
      expression: "editForm['newstitle']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Text :",
      "prop": "newstext"
    }
  }, [_c('wysiwyg', {
    model: {
      value: (_vm.editForm['newstext']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'newstext', $$v)
      },
      expression: "editForm['newstext']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Hot news :"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "red",
      "inactive-color": "#ccc"
    },
    model: {
      value: (_vm.editForm['hotnews']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'hotnews', $$v)
      },
      expression: "editForm['hotnews']"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" More")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Image :",
      "prop": "newsimage"
    }
  }, [_c('el-input', {
    attrs: {
      "title": "Use public or relative url, like: 'http://server/image.jpg', '/static/img/tui-logo.png' or empty for none.",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['newsimage']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'newsimage', $$v)
      },
      expression: "editForm['newsimage']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Link :",
      "prop": "newslink"
    }
  }, [_c('el-input', {
    attrs: {
      "title": "Use public or relative url, like: 'http://server/page.html' or empty for none.",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['newslink']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'newslink', $$v)
      },
      expression: "editForm['newslink']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Show From/To :"
    }
  }, [_c('el-date-picker', {
    staticClass: "startTimeBox",
    attrs: {
      "type": "date",
      "clearable": true,
      "placeholder": "Select Date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm['showfrom']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'showfrom', $$v)
      },
      expression: "editForm['showfrom']"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "startTimeBox",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "date",
      "clearable": true,
      "placeholder": "Select Date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm['showtill']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'showtill', $$v)
      },
      expression: "editForm['showtill']"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butCancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butSave))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticStyle: {
      "padding-bottom": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "editForm",
    staticStyle: {
      "min-height": "450px"
    },
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Import")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Site:",
      "prop": "site"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Site"
    },
    model: {
      value: (_vm.sitecode),
      callback: function($$v) {
        _vm.sitecode = $$v
      },
      expression: "sitecode"
    }
  }, _vm._l((_vm.sites), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.code + ' - ' + item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "XML : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "type": "textarea",
      "rows": "30"
    },
    model: {
      value: (_vm.xmldata),
      callback: function($$v) {
        _vm.xmldata = $$v
      },
      expression: "xmldata"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('br'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "Upload"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.Upload.apply(null, arguments)
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "default",
      "icon": "edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeForm.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 634:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._l((this.content), function(x) {
    return _c('el-card', {
      key: x.id,
      staticClass: "box-card-component",
      style: (_vm.bodystyle(x.hotnews))
    }, [_c('div', {
      staticClass: "box-card-header",
      attrs: {
        "xslot": "header"
      }
    }, [_c('h1', [(x.hotnews) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("HOT NEWS: ")]) : _vm._e(), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(x.newstitle)
      }
    }), _c('br'), _vm._v(" "), _c('center', [(x.id == 0) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "small",
        "xicon": "el-icon-edit"
      },
      on: {
        "click": function($event) {
          return _vm.OpenMoreNews()
        }
      }
    }, [_vm._v("Other News")]) : _vm._e()], 1)], 1)]), _vm._v(" "), (x.id > 0) ? _c('div', [(x.newsimage != '') ? _c('img', {
      staticStyle: {
        "float": "right",
        "width": "250px",
        "margin-bottom": "20px"
      },
      attrs: {
        "src": x.newsimage
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(x.newstext)
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "break": "both",
        "font-size": "10px",
        "float": "right",
        "margin-bottom": "5px",
        "clear": "both"
      }
    }, [_vm._v("Created: " + _vm._s(x.newscreated) + " By: " + _vm._s(x.newsby))])]) : _vm._e()])
  }), _vm._v(" "), _vm._m(0)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_vm._v("\n    This site is intended for internal use only."), _c('br'), _c('br'), _vm._v("\n    For more information, bugs or additional support, please contact "), _c('a', {
    attrs: {
      "href": "mailto:ruud.noordermeer@tui.nl"
    }
  }, [_vm._v("ruud.noordermeer@tui.nl")]), _vm._v(" or\n    "), _c('a', {
    attrs: {
      "href": "mailto:Joeri.Bossuyt@tui.be"
    }
  }, [_vm._v("Joeri.Bossuyt@tui.be")]), _vm._v("."), _c('br'), _c('br'), _vm._v("\n    Thanks for your time!"), _c('br'), _c('br'), _vm._v("\n    Last Modified: 2022-11-16"), _c('br'), _vm._v("\n    By team: TUI Western Region Delivery (WRD)\n    ")])
}]}

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v(_vm._s(_vm.lang.butSearch))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.searchFilter = '';
        _vm.getRecords();
      }
    }
  }, [_vm._v("C")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.lang.butAdd))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "Code",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "country",
      "label": "Country",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "disabled": "",
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "page-sizes": [10, 15, 25, 50, 100],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "125px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Supplier")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Code : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['code']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'code', $$v)
      },
      expression: "editForm['code']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['name']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'name', $$v)
      },
      expression: "editForm['name']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Country : "
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['country']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'country', $$v)
      },
      expression: "editForm['country']"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butCancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butSave))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.startSearch.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v(_vm._s(_vm.lang.butSearch))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.searchFilter = '';
        _vm.getRecords();
      }
    }
  }, [_vm._v("C")])], 1), _vm._v(" "), (this.userdept.includes('WRD')) ? _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.lang.butAdd))])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "department",
      "label": "Owner",
      "min-width": "50",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "group",
      "label": "Group",
      "min-width": "129",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "Code",
      "min-width": "129",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "Title",
      "min-width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "disabled": !_vm.userdept.includes('WRD'),
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "current-page": _vm.currentPage,
      "page-sizes": [10, 15, 25, 50, 100, 1000],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" News")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Group :",
      "prop": "group"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['group']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'group', $$v)
      },
      expression: "editForm['group']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Code :",
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['code']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'code', $$v)
      },
      expression: "editForm['code']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Owner :",
      "prop": "department"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": this.editMode == 'save',
      "placeholder": "Department to Used"
    },
    model: {
      value: (_vm.editForm['department']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'department', $$v)
      },
      expression: "editForm['department']"
    }
  }, _vm._l((_vm.codes.depts), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.code + ' - ' + item.value,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Title :",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['title']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'title', $$v)
      },
      expression: "editForm['title']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Text :",
      "prop": "text"
    }
  }, [_c('wysiwyg', {
    staticStyle: {
      "height": "300px !important"
    },
    model: {
      value: (_vm.editForm['text']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'text', $$v)
      },
      expression: "editForm['text']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Info Link :",
      "prop": "text"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['link']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'link', $$v)
      },
      expression: "editForm['link']"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butCancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butSave))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._l((this.content), function(x) {
    return _c('el-card', {
      key: x.id,
      staticClass: "box-card-component",
      style: (_vm.bodystyle(x.hotnews))
    }, [_c('div', {
      staticClass: "box-card-header",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('h1', [(x.hotnews) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("HOT NEWS: ")]) : _vm._e(), _c('span', {
      domProps: {
        "innerHTML": _vm._s(x.newstitle)
      }
    })])]), _vm._v(" "), _c('div', [(x.newsimage != '') ? _c('img', {
      staticStyle: {
        "float": "right",
        "width": "250px",
        "margin-bottom": "20px"
      },
      attrs: {
        "src": x.newsimage
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(x.newstext)
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "break": "both",
        "font-size": "10px",
        "float": "right",
        "margin-bottom": "5px",
        "clear": "both"
      }
    }, [_vm._v("Created: " + _vm._s(x.newscreated) + " By: " + _vm._s(x.newsby))])])])
  }), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "current-page": _vm.currentPage,
      "page-sizes": [10, 15, 25, 50, 100, 1000],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " items found")])], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 639:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticStyle: {
      "padding-bottom": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "editForm",
    staticStyle: {
      "min-height": "450px"
    },
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Import")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Action:",
      "prop": "action"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Action"
    },
    model: {
      value: (_vm.action),
      callback: function($$v) {
        _vm.action = $$v
      },
      expression: "action"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(item.code))])])
  }), 1)], 1), _vm._v(" "), (this.action == 'DEL_DOSSITE' || this.action == 'REB_DOSSITE' || this.action == 'TAB_BACKUP' || this.action == 'TAB_RESTORE') ? _c('el-form-item', {
    attrs: {
      "label": "Site:",
      "prop": "site"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Site"
    },
    model: {
      value: (_vm.site),
      callback: function($$v) {
        _vm.site = $$v
      },
      expression: "site"
    }
  }, _vm._l((_vm.sites), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.code + ' - ' + item.name,
        "value": item.code
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (this.action == 'DEL_ONEDOS' || this.action == 'REB_ONEDOS') ? _c('el-form-item', {
    attrs: {
      "label": "Dossier:",
      "prop": "site"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px",
      "xfont-family": "system",
      "xfont-size": "12px"
    },
    model: {
      value: (_vm.dosid),
      callback: function($$v) {
        _vm.dosid = $$v
      },
      expression: "dosid"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.action == 'TAB_BACKUP' || this.action == 'TAB_RESTORE') ? _c('el-form-item', {
    attrs: {
      "label": "Table:",
      "prop": "table"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Table"
    },
    model: {
      value: (_vm.table),
      callback: function($$v) {
        _vm.table = $$v
      },
      expression: "table"
    }
  }, _vm._l((_vm.tables), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.code,
        "value": item.code
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Access Pin:",
      "prop": "key"
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin-right": "20px",
      "width": "300px"
    },
    attrs: {
      "type": "password",
      "show-password": ""
    },
    model: {
      value: (_vm.key),
      callback: function($$v) {
        _vm.key = $$v
      },
      expression: "key"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "xstyle": "float:right;",
      "type": "warning",
      "size": "small",
      "icon": "Upload"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.Execute.apply(null, arguments)
      }
    }
  }, [_vm._v("Execute This Action")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Results : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "20"
    },
    model: {
      value: (_vm.results),
      callback: function($$v) {
        _vm.results = $$v
      },
      expression: "results"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 640:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_vm._v("Site:")]), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Site"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.sitecode),
      callback: function($$v) {
        _vm.sitecode = $$v
      },
      expression: "sitecode"
    }
  }, _vm._l((_vm.codes.sites), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.code + ' - ' + item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Vanaf periode"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.periode),
      callback: function($$v) {
        _vm.periode = $$v
      },
      expression: "periode"
    }
  }, _vm._l((_vm.codes.periods), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v("Filter")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleImport
    }
  }, [_vm._v("Import")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "dosid",
      "label": "Dossier",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bookperiod",
      "label": "Period",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "booker",
      "label": "Booker",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "destination",
      "label": "Destination",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "departuredate",
      "label": "Departure",
      "width": "160",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "prop": "fin.amount",
      "label": "Amount",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.util.formatMoney(scope.row.fin.amount)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bookstatus",
      "label": "BS",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "loadstatus",
      "label": "LS",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "180",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "icon": "el-icon-chat-line-square"
          },
          on: {
            "click": function($event) {
              return _vm.handleView(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "xtype": "success",
            "size": "small",
            "icon": "el-icon-view"
          },
          on: {
            "click": function($event) {
              return _vm.handleXml(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "disabled": "",
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes",
      "total": _vm.mainTotal,
      "page-sizes": [10, 15, 25, 50, 100],
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin-right": "4px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.mainTotal) + " records / Page\n\t\t    "), _c('el-input-number', {
    staticStyle: {
      "width": "110px",
      "margin-top": "3px"
    },
    attrs: {
      "size": "mini",
      "min": 1,
      "max": _vm.maxNextValue
    },
    on: {
      "change": _vm.loadNextPage
    },
    model: {
      value: (_vm.nextPage),
      callback: function($$v) {
        _vm.nextPage = $$v
      },
      expression: "nextPage"
    }
  }), _vm._v(" of " + _vm._s(_vm.pageCount) + " ")], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "140px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    staticStyle: {
      "height": "440px"
    },
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.clickTab
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "T1"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Dossier")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Dossier/Status : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['dosid']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'dosid', $$v)
      },
      expression: "editForm['dosid']"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100px",
      "float": "right"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['bookstatus']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'bookstatus', $$v)
      },
      expression: "editForm['bookstatus']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Booker : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['booker']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'booker', $$v)
      },
      expression: "editForm['booker']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Main Dest : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['destination']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'destination', $$v)
      },
      expression: "editForm['destination']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bookdate : "
    }
  }, [_c('el-date-picker', {
    staticClass: "startTimeBox",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "type": "datetime",
      "clearable": true,
      "placeholder": "Select Date and Time",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm['bookdate']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'bookdate', $$v)
      },
      expression: "editForm['bookdate']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Departuredate : "
    }
  }, [_c('el-date-picker', {
    staticClass: "startTimeBox",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "type": "datetime",
      "clearable": true,
      "placeholder": "Select Date and Time",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm['departuredate']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'departuredate', $$v)
      },
      expression: "editForm['departuredate']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Returndate : "
    }
  }, [_c('el-date-picker', {
    staticClass: "startTimeBox",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "type": "datetime",
      "clearable": true,
      "placeholder": "Select Date and Time",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm['returndate']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'returndate', $$v)
      },
      expression: "editForm['returndate']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('hr', {
    attrs: {
      "color": "#eee"
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Dossier Geladen : "
    }
  }, [_c('el-date-picker', {
    staticClass: "startTimeBox",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "type": "datetime",
      "clearable": true,
      "placeholder": "Select Date and Time",
      "format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.editForm['loaddate']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'loaddate', $$v)
      },
      expression: "editForm['loaddate']"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "LOCATE"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Segments")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Accommodation : "
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "8",
      "readonly": "readonly",
      "type": "textarea"
    },
    model: {
      value: (_vm.detailLocate),
      callback: function($$v) {
        _vm.detailLocate = $$v
      },
      expression: "detailLocate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transport : "
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "9",
      "readonly": "readonly",
      "type": "textarea"
    },
    model: {
      value: (_vm.detailTransport),
      callback: function($$v) {
        _vm.detailTransport = $$v
      },
      expression: "detailTransport"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "FIN"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Finance")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Details : "
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "8",
      "readonly": "readonly",
      "type": "textarea"
    },
    model: {
      value: (_vm.detailFin),
      callback: function($$v) {
        _vm.detailFin = $$v
      },
      expression: "detailFin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Purchase : "
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "9",
      "readonly": "readonly",
      "type": "textarea"
    },
    model: {
      value: (_vm.detailPur),
      callback: function($$v) {
        _vm.detailPur = $$v
      },
      expression: "detailPur"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butCancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butSave))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "90%",
      "title": "View Original XML",
      "visible": _vm.viewXmlVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.viewXmlVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Dossier:",
      "prop": "dossier"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.dossier),
      callback: function($$v) {
        _vm.dossier = $$v
      },
      expression: "dossier"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "XML File:",
      "prop": "id"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.xmlfile),
      callback: function($$v) {
        _vm.xmlfile = $$v
      },
      expression: "xmlfile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "label": "XML : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "25"
    },
    model: {
      value: (_vm.xmldata),
      callback: function($$v) {
        _vm.xmldata = $$v
      },
      expression: "xmldata"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewXmlVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "90%",
      "title": "View Base Dossier Details",
      "visible": _vm.viewDetailsVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.viewDetailsVisible = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "min-height": "450px"
    },
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Dossier :",
      "prop": "dossier"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.dossier),
      callback: function($$v) {
        _vm.dossier = $$v
      },
      expression: "dossier"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100px",
      "float": "Right"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Type"
    },
    on: {
      "change": _vm.reloadData
    },
    model: {
      value: (_vm.outtype),
      callback: function($$v) {
        _vm.outtype = $$v
      },
      expression: "outtype"
    }
  }, _vm._l((_vm.outtypes), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "label": "JSON : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "28"
    },
    model: {
      value: (_vm.outdata),
      callback: function($$v) {
        _vm.outdata = $$v
      },
      expression: "outdata"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewDetailsVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "min-width": "1020px !important"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "xlabel-width": "50px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "xstyle": "margin:0",
      "label": "Site :"
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Site"
    },
    on: {
      "change": _vm.filterReports
    },
    model: {
      value: (_vm.sitecode),
      callback: function($$v) {
        _vm.sitecode = $$v
      },
      expression: "sitecode"
    }
  }, _vm._l((_vm.codes.sites), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.code + ' - ' + item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Report"
    },
    model: {
      value: (_vm.reportsel),
      callback: function($$v) {
        _vm.reportsel = $$v
      },
      expression: "reportsel"
    }
  }, _vm._l((_vm.selectviews), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.code + ' - ' + item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Period"
    },
    on: {
      "change": _vm.checkPeriode
    },
    model: {
      value: (_vm.periodsel),
      callback: function($$v) {
        _vm.periodsel = $$v
      },
      expression: "periodsel"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "( Manual Period )",
      "value": "man"
    }
  }), _vm._v(" "), _vm._l((_vm.codes.periods), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Output"
    },
    model: {
      value: (_vm.output),
      callback: function($$v) {
        _vm.output = $$v
      },
      expression: "output"
    }
  }, _vm._l((_vm.outtypes), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.manType),
      callback: function($$v) {
        _vm.manType = $$v
      },
      expression: "manType"
    }
  }, [_vm._v("Select Type ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.reportsel == '',
      "type": _vm.buttonType,
      "icon": "el-icon-open",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.showReport();
      }
    }
  }, [_vm._v("Open")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(this.periodsel == 'man') ? _c('span', [_c('el-form-item', {
    attrs: {
      "label": "Period:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin": "0",
      "width": "120px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.periodFrom),
      callback: function($$v) {
        _vm.periodFrom = $$v
      },
      expression: "periodFrom"
    }
  }, _vm._l((_vm.codes.manPeriods), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Till:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.periodTill),
      callback: function($$v) {
        _vm.periodTill = $$v
      },
      expression: "periodTill"
    }
  }, _vm._l((_vm.codes.manPeriods), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (this.manType) ? _c('span', [_c('el-form-item', {
    attrs: {
      "label": "Type :"
    }
  }, [_c('el-select', {
    staticStyle: {
      "min-width": "575px",
      "x": "500px"
    },
    attrs: {
      "multiple": "",
      "size": "mini",
      "Placeholder": "Status"
    },
    model: {
      value: (_vm.bookStatSel),
      callback: function($$v) {
        _vm.bookStatSel = $$v
      },
      expression: "bookStatSel"
    }
  }, _vm._l((_vm.codes.bookstatus), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1)], 1) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "padding": "0 10px",
      "line-height": "1.5em",
      "font-size": "12px",
      "border": "1px solid #ccc",
      "height": "600px",
      "overflow": "auto"
    },
    attrs: {
      "id": "area"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.reportdata))])])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [(_vm.reportLoaded) ? _c('el-button', {
    attrs: {
      "type": "warning",
      "icon": "el-icon-download",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.download();
      }
    }
  }, [_vm._v("Download " + _vm._s(_vm.lastType) + " as File")]) : _vm._e(), _vm._v(" "), (_vm.reportLoaded && this.lastType != 'TABLE') ? _c('el-checkbox', {
    staticStyle: {
      "margin-left": "20px"
    },
    model: {
      value: (_vm.openApp),
      callback: function($$v) {
        _vm.openApp = $$v
      },
      expression: "openApp"
    }
  }, [_vm._v("Open App")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-form', {
    staticClass: "demo-ruleForm login-container grijs",
    attrs: {
      "model": _vm.passwordForm,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "60px",
      "margin-top": "10px"
    }
  }, [_c('span', [_c('img', {
    staticStyle: {
      "float": "left",
      "height": "55px",
      "xwidth": "50px",
      "margin-top": "-5px"
    },
    attrs: {
      "src": __webpack_require__(602)
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("EnergyWatch")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Change your Password")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "margin": "20px 0",
      "font-family": "Tahoma"
    }
  }, [_vm._v(" You have requested a password change, \n    so we send you this link. Please use the following field to enter a new value.\n    Each Password should be minimal 8 characters.")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "show-password": "",
      "auto-complete": "off",
      "placeholder": "Your new password"
    },
    model: {
      value: (_vm.passwordForm.password),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "password", $$v)
      },
      expression: "passwordForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "prop": "retype"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "show-password": "",
      "auto-complete": "off",
      "placeholder": "Retype password"
    },
    model: {
      value: (_vm.passwordForm.retype),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "retype", $$v)
      },
      expression: "passwordForm.retype"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [(_vm.passwordForm.password != _vm.passwordForm.retype) ? _c('span', {
    staticStyle: {
      "float": "left",
      "font-size": "12px",
      "color": "red"
    }
  }, [_vm._v("Passwords are not the same!")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.isPasswordInValid(),
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Change")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.getRecords()
      }
    }
  }, [_vm._v("Refresh")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "LogName",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mod",
      "label": "Created",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-view"
          },
          on: {
            "click": function($event) {
              return _vm.handleView(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "page-sizes": [10, 15, 25, 50, 100],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "View Log",
      "visible": _vm.editFormVisible,
      "width": "90%",
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" XLog")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['name']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'name', $$v)
      },
      expression: "editForm['name']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Created : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['mod']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'mod', $$v)
      },
      expression: "editForm['mod']"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "15"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butCancel))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v(_vm._s(_vm.lang.butSearch))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.searchFilter = '';
        _vm.getRecords();
      }
    }
  }, [_vm._v("C")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.lang.butAdd))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "View",
      "width": "80",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "active",
      "label": "Active",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "disabled": "",
            "width": 35,
            "xactive-color": "#FFCE9F",
            "inactive-color": "#ccc"
          },
          model: {
            value: (scope.row.active),
            callback: function($$v) {
              _vm.$set(scope.row, "active", $$v)
            },
            expression: "scope.row.active"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "cmdIcon",
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-d-arrow-left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeForm.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": _vm.pagewidth > 800 ? 'prev,pager,next,jumper,sizes' : 'prev,pager,next,jumper',
      "total": _vm.mainTotal,
      "current-page": _vm.currentPage,
      "page-sizes": [10, 15, 25, 50, 100, 1000],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "125px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" View")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "View : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['code']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'code', $$v)
      },
      expression: "editForm['code']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name : "
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['name']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'name', $$v)
      },
      expression: "editForm['name']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sites : "
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['sitelist']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'sitelist', $$v)
      },
      expression: "editForm['sitelist']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " Fields : "
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "5",
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm['select']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'select', $$v)
      },
      expression: "editForm['select']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Active : "
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 35,
      "xactive-color": "#FDAA59",
      "inactive-color": "#ccc"
    },
    model: {
      value: (_vm.editForm['active']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'active', $$v)
      },
      expression: "editForm['active']"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butCancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butSave))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticStyle: {
      "margin-top": "20px",
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "mainForm",
    attrs: {
      "model": _vm.mainForm,
      "label-width": "120px",
      "rules": _vm.mainFormRules
    }
  }, [(_vm.mainForm.pwdreset == true) ? _c('el-col', {
    staticStyle: {
      "background-color": "#ff9900",
      "color": "white",
      "padding": "15px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n          Your password has expired and needs to be reset. Please enter a new value in the password field below.'.\n          ")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Login : ",
      "prop": "Usercode"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "disabled",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.mainForm.usercode),
      callback: function($$v) {
        _vm.$set(_vm.mainForm, "usercode", $$v)
      },
      expression: "mainForm.usercode"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name :",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.mainForm.Usercode == 'master',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.mainForm.username),
      callback: function($$v) {
        _vm.$set(_vm.mainForm, "username", $$v)
      },
      expression: "mainForm.username"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Your Avatar:",
      "prop": "useravatar"
    }
  }, [_c('img', {
    staticClass: "icoon",
    attrs: {
      "src": _vm.curIcon
    }
  }), _vm._v(" "), (_vm.mainForm.usercode != 'master') ? _c('el-select', {
    attrs: {
      "clearable": "",
      "autocomplete": "",
      "filterable": "",
      "value-key": "mainForm.useravatar",
      "placeholder": "Select Icon"
    },
    on: {
      "change": _vm.showChanged
    },
    model: {
      value: (_vm.mainForm.useravatar),
      callback: function($$v) {
        _vm.$set(_vm.mainForm, "useravatar", $$v)
      },
      expression: "mainForm.useravatar"
    }
  }, _vm._l((_vm.codes.Img), function(item) {
    return _c('el-option', {
      key: item.Code,
      staticStyle: {
        "height": "45px"
      },
      attrs: {
        "label": item.Desc,
        "value": item.Url
      }
    }, [_c('img', {
      staticClass: "icoon",
      attrs: {
        "src": item.IconUrl
      }
    }), _c('span', {
      staticStyle: {
        "margin": "5px 10px",
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.Desc))])])
  }), 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.mainForm.usercode != 'master') ? _c('el-col', {
    staticStyle: {
      "background-color": "#ddd",
      "padding-top": "10px",
      "xmargin-top": "10px"
    }
  }, [(_vm.mainForm.pwdreset == false) ? _c('div', {
    staticStyle: {
      "font-family": "verdana",
      "font-size": "12px",
      "color": "blue",
      "font-weight": "bold",
      "margin": "0 0 10px 20px"
    }
  }, [_vm._v("\n          Only use these fields if you want to change your password ! ")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "label": "Password :",
      "prop": "password"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.mainForm.password),
      callback: function($$v) {
        _vm.$set(_vm.mainForm, "password", $$v)
      },
      expression: "mainForm.password"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.mainForm.usercode != 'master') ? _c('el-col', {
    staticStyle: {
      "background-color": "#ddd",
      "padding-bottom": "20px",
      "margin-bottom": "10px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Re-Type PWD :",
      "prop": "password2"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.mainForm.password2),
      callback: function($$v) {
        _vm.$set(_vm.mainForm, "password2", $$v)
      },
      expression: "mainForm.password2"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [(_vm.mainForm.usercode != 'master') ? _c('el-button', {
    staticStyle: {
      "float": "Right"
    },
    attrs: {
      "type": "success",
      "size": "small",
      "loading": _vm.mainLoading,
      "icon": "el-icon-edit"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.mainSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Store")]) : _vm._e(), _vm._v(" "), (_vm.mainForm.usercode == 'master') ? _c('div', {
    staticStyle: {
      "font-family": "verdana",
      "margin-left": "px"
    }
  }, [_vm._v(" User 'master' cannot be modified. Please contact admin!")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dataLoading),
      expression: "dataLoading"
    }],
    staticClass: "toolbar",
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "label-width": "140px"
    }
  }, [_vm._v("        \n        Booking *:\n          "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "small",
      "placeholder": "ID like '1234567'"
    },
    model: {
      value: (_vm.booking),
      callback: function($$v) {
        _vm.booking = $$v
      },
      expression: "booking"
    }
  }), _vm._v("\n        Departure :\n          "), _c('el-date-picker', {
    staticStyle: {
      "width": "135px"
    },
    attrs: {
      "size": "small",
      "type": "date",
      "placeholder": "Departure date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.departure),
      callback: function($$v) {
        _vm.departure = $$v
      },
      expression: "departure"
    }
  }), _vm._v("\n        Flight :  "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "small",
      "placeholder": "or1234"
    },
    model: {
      value: (_vm.flightnum),
      callback: function($$v) {
        _vm.flightnum = $$v
      },
      expression: "flightnum"
    }
  }), _vm._v("\n        Traject :\n          "), _c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "placeholder": "Flight info from/to: AMS-MAD"
    },
    model: {
      value: (_vm.traject),
      callback: function($$v) {
        _vm.traject = $$v
      },
      expression: "traject"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.allVersions),
      callback: function($$v) {
        _vm.allVersions = $$v
      },
      expression: "allVersions"
    }
  }, [_vm._v(" AllVersions")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startCheck
    }
  }, [_vm._v("Check Status")]), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), (_vm.result != '') ? _c('el-col', {
    staticStyle: {
      "margin": "10px 0 10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n    Results:\n\t  ")]) : _vm._e(), _vm._v(" "), (_vm.result != '') ? _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dataLoading),
      expression: "dataLoading"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    staticStyle: {
      "line-height": "1.5em"
    },
    attrs: {
      "type": "textarea",
      "rows": "20"
    },
    model: {
      value: (_vm.result),
      callback: function($$v) {
        _vm.result = $$v
      },
      expression: "result"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container grijs",
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "visible": _vm.loginVisible,
      "label-position": "left",
      "label-width": "0px"
    },
    on: {
      "update:visible": function($event) {
        _vm.loginVisible = $event
      }
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "45px",
      "margin-top": "0",
      "color": "#409EFF"
    }
  }, [_c('span', [_c('img', {
    staticStyle: {
      "float": "left",
      "height": "55px",
      "xwidth": "50px",
      "margin-top": "-5px",
      "border-radius": "4px"
    },
    attrs: {
      "src": __webpack_require__(603)
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("WRD Service App")]), _c('br'), _vm._v(" "), (_vm.loginMode < 2) ? _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Login "), _c('span', {
    staticClass: "special"
  }, [_vm._v(_vm._s(this.stage))])]) : _c('span', {
    class: _vm.stageClass,
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Tui WRD")])]), _vm._v(" "), (_vm.loginMode != 2) ? _c('span', [_c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    ref: "account",
    attrs: {
      "type": "text",
      "autofocus": "",
      "auto-complete": "off",
      "placeholder": "Your Logincode"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "and password",
      "show-password": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit2.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), (_vm.loginMode != 2) ? _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-top": "-10px",
      "float": "right"
    },
    attrs: {
      "type": "text",
      "loading": _vm.logining,
      "show-password": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetPassword.apply(null, arguments)
      }
    }
  }, [_vm._v("Reset Password")])], 1) : _vm._e()], 1) : _c('span', [_c('center', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("Start Application")])], 1)], 1), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-size": "9px",
      "font-family": "verdana"
    }
  }, [_c('center', [_vm._v("©2022 Tui-WRD. Created by Ruud Noordermeer ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Reset your Password",
      "visible": _vm.resetVisible,
      "width": "300px"
    },
    on: {
      "update:visible": function($event) {
        _vm.resetVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "resetForm",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "model": _vm.resetForm,
      "label-width": "60px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email :",
      "prop": "deptemail"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.resetForm['email']),
      callback: function($$v) {
        _vm.$set(_vm.resetForm, 'email', $$v)
      },
      expression: "resetForm['email']"
    }
  })], 1), _vm._v(" "), _c('el-col', [_c('div', {
    staticStyle: {
      "font-size": "13px",
      "margin-left": "60px",
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n         NOTE: THIS FUNCTION IS NOT YET AVAILABLE!!"), _c('br'), _c('br'), _vm._v("\n         After pressing the 'Reset' button we will send you an email"), _c('br'), _vm._v("with further instructions.\n\t     ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.isEmailInvalid(_vm.resetForm['email']),
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v(_vm._s(_vm.lang.butSearch))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.searchFilter = '';
        _vm.getRecords();
      }
    }
  }, [_vm._v("C")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.lang.butAdd))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "anvrid",
      "label": "Anvrid",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "disabled": "",
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "page-sizes": [10, 15, 25, 50, 100],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "125px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Anvr")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Anvrid : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['anvrid']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'anvrid', $$v)
      },
      expression: "editForm['anvrid']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['name']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'name', $$v)
      },
      expression: "editForm['name']"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butCancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butSave))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "autocomplete": "",
      "filterable": "",
      "placeholder": "Select Statistic"
    },
    on: {
      "change": _vm.openGroup
    },
    model: {
      value: (_vm.stat),
      callback: function($$v) {
        _vm.stat = $$v
      },
      expression: "stat"
    }
  }, _vm._l((_vm.codes.statcodes), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.openGroup
    }
  }, [_vm._v("Open")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.openGroup
    }
  }, [_vm._v("Refresh")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "cell-style": {
        height: '32px'
      },
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "Created",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "details",
      "label": "Input",
      "min-width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "align": "right",
      "label": "Total",
      "width": "55"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.total != 0) ? scope.row.total : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "added",
      "align": "right",
      "label": "Added",
      "width": "65"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.added != 0) ? scope.row.added : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modified",
      "align": "right",
      "label": "Modified",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.modified != 0) ? scope.row.modified : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activated",
      "align": "right",
      "label": "Activated",
      "width": "85"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.activated != 0) ? scope.row.activated : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deleted",
      "align": "right",
      "label": "Deleted",
      "width": "75"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.deleted != 0) ? scope.row.deleted : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "errors",
      "align": "right",
      "label": "Errors",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.errors != 0) ? scope.row.errors : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "errors",
      "align": "right",
      "label": "Skipped",
      "width": "72"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.skipped != 0) ? scope.row.skipped : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "78",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small",
            "icon": "el-icon-view"
          },
          on: {
            "click": function($event) {
              return _vm.showLog(scope.row)
            }
          }
        }, [_vm._v("Log")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "page-sizes": [10, 15, 25, 50, 100],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "90%",
      "title": "View Messages & Errors",
      "visible": _vm.MessagesVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.MessagesVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "25"
    },
    model: {
      value: (_vm.messages),
      callback: function($$v) {
        _vm.messages = $$v
      },
      expression: "messages"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.MessagesVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v(_vm._s(_vm.lang.butSearch))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.searchFilter = '';
        _vm.getRecords();
      }
    }
  }, [_vm._v("C")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.lang.butAdd))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "Site",
      "width": "80",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "active",
      "label": "Active",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "disabled": "",
            "width": 35,
            "xactive-color": "#FFCE9F",
            "inactive-color": "#ccc"
          },
          model: {
            value: (scope.row.active),
            callback: function($$v) {
              _vm.$set(scope.row, "active", $$v)
            },
            expression: "scope.row.active"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "cmdIcon",
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-d-arrow-left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeForm.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": _vm.pagewidth > 800 ? 'prev,pager,next,jumper,sizes' : 'prev,pager,next,jumper',
      "total": _vm.mainTotal,
      "current-page": _vm.currentPage,
      "page-sizes": [10, 15, 25, 50, 100, 1000],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "125px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" site")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Site : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['code']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'code', $$v)
      },
      expression: "editForm['code']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['name']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'name', $$v)
      },
      expression: "editForm['name']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email : "
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['email']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'email', $$v)
      },
      expression: "editForm['email']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Import Check : "
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['importName']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'importName', $$v)
      },
      expression: "editForm['importName']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Active : "
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 35,
      "xactive-color": "#FDAA59",
      "inactive-color": "#ccc"
    },
    model: {
      value: (_vm.editForm['active']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'active', $$v)
      },
      expression: "editForm['active']"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butCancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butSave))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.startSearch.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v(_vm._s(_vm.lang.butSearch))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.searchFilter = '';
        _vm.getRecords();
      }
    }
  }, [_vm._v("C")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.lang.butAdd))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "usercode",
      "label": "UserCode",
      "min-width": "150",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "icoon",
          attrs: {
            "src": "./static/" + scope.row.useravatar
          }
        }), _vm._v(" "), _c('div', {
          staticStyle: {
            "margin": "7px 40px"
          }
        }, [_vm._v(_vm._s(scope.row.usercode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "Name",
      "min-width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "useremail",
      "label": "Email",
      "min-width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userroles",
      "label": "Role(s)",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "departments",
      "label": "Depts",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stages",
      "label": "Stages",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "current-page": _vm.currentPage,
      "page-sizes": [10, 15, 25, 50, 100, 1000],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "150px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" User")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UserCode:",
      "prop": "usercode"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['usercode']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'usercode', $$v)
      },
      expression: "editForm['usercode']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "User Role(s) :",
      "prop": "uroles"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "Select User Role(s)"
    },
    model: {
      value: (_vm.uroles),
      callback: function($$v) {
        _vm.uroles = $$v
      },
      expression: "uroles"
    }
  }, _vm._l((_vm.codes.roles), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Department(s) :",
      "prop": "udepts"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "Select Department(s)"
    },
    model: {
      value: (_vm.udepts),
      callback: function($$v) {
        _vm.udepts = $$v
      },
      expression: "udepts"
    }
  }, _vm._l((_vm.codes.depts), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Allowed Stage(s) :",
      "prop": "ustages"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "Select Allowed Stages"
    },
    model: {
      value: (_vm.ustages),
      callback: function($$v) {
        _vm.ustages = $$v
      },
      expression: "ustages"
    }
  }, _vm._l((_vm.stageList), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name :",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['username']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'username', $$v)
      },
      expression: "editForm['username']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email :",
      "prop": "useremail"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['useremail']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'useremail', $$v)
      },
      expression: "editForm['useremail']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Password:"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['password']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'password', $$v)
      },
      expression: "editForm['password']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Avatar :"
    }
  }, [_c('img', {
    staticClass: "icoon",
    attrs: {
      "src": _vm.curIcon
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "clearable": "",
      "autocomplete": "",
      "filterable": "",
      "value-key": "editForm.userImg",
      "placeholder": "Select Icon"
    },
    on: {
      "change": _vm.showChanged
    },
    model: {
      value: (_vm.editForm.useravatar),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "useravatar", $$v)
      },
      expression: "editForm.useravatar"
    }
  }, _vm._l((_vm.codes.Img), function(item) {
    return _c('el-option', {
      key: item.code,
      staticStyle: {
        "height": "45px"
      },
      attrs: {
        "label": item.desc,
        "value": item.value
      }
    }, [_c('img', {
      staticClass: "icoon",
      attrs: {
        "src": './static/' + item.value
      }
    }), _c('span', {
      staticStyle: {
        "margin": "5px 10px",
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.desc))])])
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "5px",
      "line-height": "14px",
      "font-size": "10px",
      "float": "right"
    },
    attrs: {
      "title": _vm.editForm['_udet']
    }
  }, [_vm._v("\n            Hash: " + _vm._s(_vm.editForm['pwdhash'])), _c('br'), _vm._v("\n            Pwd Modified: " + _vm._s(_vm.editForm['pwdmodified']) + "\n          ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UserToken :",
      "prop": "usertoken"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "width": "10",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['usertoken']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'usertoken', $$v)
      },
      expression: "editForm['usertoken']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [(_vm.editForm['usertokenDel'] != true) ? _c('span', [_c('el-switch', {
    attrs: {
      "width": 40,
      "xactive-color": "green",
      "active-color": "#58a632",
      "inactive-color": "#ccc"
    },
    model: {
      value: (_vm.editForm['usertokenGen']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'usertokenGen', $$v)
      },
      expression: "editForm['usertokenGen']"
    }
  }), _vm._v("       Generate        \n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.editForm['usertoken'] != '' && _vm.editForm['usertokenGen'] != true) ? _c('span', [_c('el-switch', {
    attrs: {
      "width": 40,
      "active-color": "red",
      "xactive-color": "#58a632",
      "inactive-color": "#ccc"
    },
    model: {
      value: (_vm.editForm['usertokenDel']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'usertokenDel', $$v)
      },
      expression: "editForm['usertokenDel']"
    }
  }), _vm._v("          Clear\n            ")], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n          Reset PWD:   \n          "), _c('el-switch', {
    attrs: {
      "active-color": "#409EFF",
      "inactive-color": "#ccc"
    },
    model: {
      value: (_vm.editForm['pwdreset']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'pwdreset', $$v)
      },
      expression: "editForm['pwdreset']"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butCancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butSave))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 652:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "clearable": "",
      "autocomplete": "",
      "filterable": "",
      "placeholder": "Select Global Statistic"
    },
    on: {
      "change": _vm.openGroup
    },
    model: {
      value: (_vm.stat),
      callback: function($$v) {
        _vm.stat = $$v
      },
      expression: "stat"
    }
  }, _vm._l((_vm.codes.statcodes), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.openGroup
    }
  }, [_vm._v("Open")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.openGroup
    }
  }, [_vm._v("Refresh")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "cell-style": {
        height: '32px'
      },
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "Subject",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "Created",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "details",
      "label": "Input",
      "min-width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "Total",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.total != 0) ? scope.row.total : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "added",
      "label": "Added",
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.added != 0) ? scope.row.added : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modified",
      "label": "Modified",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.modified != 0) ? scope.row.modified : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deleted",
      "label": "Deleted",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.deleted != 0) ? scope.row.deleted : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "errors",
      "label": "Errors",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.errors != 0) ? scope.row.errors : ''))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warnings",
      "label": "Warnings",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.warnings != 0) ? scope.row.warnings : ''))]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "page-sizes": [10, 15, 25, 50, 100],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 653:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v(_vm._s(_vm.lang.butSearch))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.searchFilter = '';
        _vm.getRecords();
      }
    }
  }, [_vm._v("C")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "niceDate",
      "label": "Created",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "file",
      "label": "Zip Name",
      "min-width": "300",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nskProcessed",
      "label": "Imported from NSK",
      "min-width": "230",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nskCount",
      "label": "NSK#",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sqsCount",
      "label": "SQS#",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sqsProcessed",
      "label": "Saved in Jits",
      "min-width": "230",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "50",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-view"
          },
          on: {
            "click": function($event) {
              return _vm.handleView(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "page-sizes": [10, 15, 25, 50, 100],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Show Load Details",
      "visible": _vm.editFormVisible,
      "width": "70%",
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "140px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.clickTab
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "MAIN"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Load Status")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "white",
      "margin": "0 0 7px 0",
      "padding": "5px",
      "width": "100%",
      "background": "#999"
    }
  }, [_c('center', [_vm._v("Imported from NSK")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Imported : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['niceDate']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'niceDate', $$v)
      },
      expression: "editForm['niceDate']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip File : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['file']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'file', $$v)
      },
      expression: "editForm['file']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip Processed : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['nskProcessed']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'nskProcessed', $$v)
      },
      expression: "editForm['nskProcessed']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Records/Sqs# : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "20%",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['nskCount']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'nskCount', $$v)
      },
      expression: "editForm['nskCount']"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['sqsCount']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'sqsCount', $$v)
      },
      expression: "editForm['sqsCount']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "white",
      "margin": "7 0 7px 0",
      "padding": "5px",
      "width": "100%",
      "background": "#999"
    }
  }, [_c('center', [_vm._v("Saved in Jits DB")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Saved On : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['sqsProcessed']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'sqsProcessed', $$v)
      },
      expression: "editForm['sqsProcessed']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Add/Mod/Del/Skip : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "20%",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['dbAddCount']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'dbAddCount', $$v)
      },
      expression: "editForm['dbAddCount']"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "20%",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['dbModCount']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'dbModCount', $$v)
      },
      expression: "editForm['dbModCount']"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "20%",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['dbDelCount']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'dbDelCount', $$v)
      },
      expression: "editForm['dbDelCount']"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['dbSkipCount']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'dbSkipCount', $$v)
      },
      expression: "editForm['dbSkipCount']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Unique Dossiers : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "20%",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['dossierCount']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'dossierCount', $$v)
      },
      expression: "editForm['dossierCount']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Has Errors : "
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": "",
      "xstyle": "width:20%"
    },
    model: {
      value: (_vm.editForm['hasErrors']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'hasErrors', $$v)
      },
      expression: "editForm['hasErrors']"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dataLoading),
      expression: "dataLoading"
    }],
    attrs: {
      "name": "DOSSIERS"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Dossiers")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "20",
      "cols": "100"
    },
    model: {
      value: (_vm.loadDossiers),
      callback: function($$v) {
        _vm.loadDossiers = $$v
      },
      expression: "loadDossiers"
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dataLoading),
      expression: "dataLoading"
    }],
    attrs: {
      "name": "ERRORS"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Errors")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "20"
    },
    model: {
      value: (_vm.loadErrors),
      callback: function($$v) {
        _vm.loadErrors = $$v
      },
      expression: "loadErrors"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "autocomplete": "",
      "filterable": "",
      "placeholder": "Select Group"
    },
    on: {
      "change": _vm.openGroup
    },
    model: {
      value: (_vm.group),
      callback: function($$v) {
        _vm.group = $$v
      },
      expression: "group"
    }
  }, _vm._l((_vm.codes.groups), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.openGroup
    }
  }, [_vm._v("Open")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.lang.butAdd))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "Code",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "desc",
      "label": "Desc",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "detail",
      "label": "Detail",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "info",
      "label": "Info",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "page-sizes": [10, 15, 25, 50, 100],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "125px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Xcode")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Group/Order : "
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "disabled": this.editMode == 'save',
      "clearable": "",
      "autocomplete": "",
      "filterable": "",
      "placeholder": "Select Group"
    },
    model: {
      value: (_vm.group),
      callback: function($$v) {
        _vm.group = $$v
      },
      expression: "group"
    }
  }, _vm._l((_vm.codes.groups), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Code : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['code']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'code', $$v)
      },
      expression: "editForm['code']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Desc : "
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['desc']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'desc', $$v)
      },
      expression: "editForm['desc']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Detail : "
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "4",
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm['detail']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'detail', $$v)
      },
      expression: "editForm['detail']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Info : "
    }
  }, [_c('wysiwyg', {
    attrs: {
      "rows": "2"
    },
    model: {
      value: (_vm.editForm['info']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'info', $$v)
      },
      expression: "editForm['info']"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butCancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butSave))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_vm._v("Site:")]), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Site"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.sitecode),
      callback: function($$v) {
        _vm.sitecode = $$v
      },
      expression: "sitecode"
    }
  }, _vm._l((_vm.codes.sites), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.code + ' - ' + item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), (this.searchField != 'Dossier' || this.searchFilter == '') ? _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Vanaf periode"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.periode),
      callback: function($$v) {
        _vm.periode = $$v
      },
      expression: "periode"
    }
  }, _vm._l((_vm.codes.periods), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_vm._v("\n          Filter: \n\t\t\t\t  "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select field"
    },
    model: {
      value: (_vm.searchField),
      callback: function($$v) {
        _vm.searchField = $$v
      },
      expression: "searchField"
    }
  }, _vm._l((_vm.searchFields), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "Search For"
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v("Filter")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleImport
    }
  }, [_vm._v("Import")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "D",
      "label": "Dossier",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "P",
      "label": "Period",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "B",
      "label": "Booker",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "X",
      "label": "Destination",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "S",
      "label": "Departure",
      "width": "110",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "prop": "A",
      "label": "Amount",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(_vm.util.formatMoney(scope.row.A)) + " ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "b",
      "label": "BS",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "l",
      "label": "LS",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "140",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-view"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "icon": "el-icon-chat-line-square"
          },
          on: {
            "click": function($event) {
              return _vm.handleView(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small",
            "icon": "el-icon-aim"
          },
          on: {
            "click": function($event) {
              return _vm.handleXml(scope.row, 0)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "page-sizes": [10, 15, 25, 50, 100],
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "140px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    staticStyle: {
      "height": "440px"
    },
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.clickTab
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "T1"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Dossier")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Dossier/Status : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['D']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'D', $$v)
      },
      expression: "editForm['D']"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100px",
      "float": "right"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['l']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'l', $$v)
      },
      expression: "editForm['l']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Booker : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['B']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'B', $$v)
      },
      expression: "editForm['B']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Main Dest : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['D']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'D', $$v)
      },
      expression: "editForm['D']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bookdate : "
    }
  }, [_c('el-date-picker', {
    staticClass: "startTimeBox",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "type": "datetime",
      "clearable": true,
      "placeholder": "Select Date and Time",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm['a']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'a', $$v)
      },
      expression: "editForm['a']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Departuredate : "
    }
  }, [_c('el-date-picker', {
    staticClass: "startTimeBox",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "type": "datetime",
      "clearable": true,
      "placeholder": "Select Date and Time",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm['S']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'S', $$v)
      },
      expression: "editForm['S']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Returndate : "
    }
  }, [_c('el-date-picker', {
    staticClass: "startTimeBox",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "type": "datetime",
      "clearable": true,
      "placeholder": "Select Date and Time",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm['e']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'e', $$v)
      },
      expression: "editForm['e']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Dossier Geladen : "
    }
  }, [_c('el-date-picker', {
    staticClass: "startTimeBox",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "type": "datetime",
      "clearable": true,
      "placeholder": "Select Date and Time",
      "format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.editForm['c']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'c', $$v)
      },
      expression: "editForm['c']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Booked By : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['m']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'm', $$v)
      },
      expression: "editForm['m']"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "LOCATE"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Segments")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Accommodation : "
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "8",
      "readonly": "readonly",
      "type": "textarea"
    },
    model: {
      value: (_vm.detailLocate),
      callback: function($$v) {
        _vm.detailLocate = $$v
      },
      expression: "detailLocate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transport : "
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "9",
      "readonly": "readonly",
      "type": "textarea"
    },
    model: {
      value: (_vm.detailTransport),
      callback: function($$v) {
        _vm.detailTransport = $$v
      },
      expression: "detailTransport"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "FIN"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Finance")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Details : "
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "18",
      "readonly": "readonly",
      "type": "textarea"
    },
    model: {
      value: (_vm.detailFin),
      callback: function($$v) {
        _vm.detailFin = $$v
      },
      expression: "detailFin"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-close",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "90%",
      "title": "View Original XML",
      "visible": _vm.viewXmlVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.viewXmlVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Dossier:",
      "prop": "dossier"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.dossier),
      callback: function($$v) {
        _vm.dossier = $$v
      },
      expression: "dossier"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Location:",
      "prop": "id"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.xmlfile),
      callback: function($$v) {
        _vm.xmlfile = $$v
      },
      expression: "xmlfile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "label": "XML : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "25"
    },
    model: {
      value: (_vm.xmldata),
      callback: function($$v) {
        _vm.xmldata = $$v
      },
      expression: "xmldata"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewXmlVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "90%",
      "title": "View Base Dossier Details",
      "visible": _vm.viewDetailsVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.viewDetailsVisible = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "min-height": "450px"
    },
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Dossier :",
      "prop": "dossier"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.dossier),
      callback: function($$v) {
        _vm.dossier = $$v
      },
      expression: "dossier"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100px",
      "float": "Right"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Type"
    },
    on: {
      "change": _vm.reloadData
    },
    model: {
      value: (_vm.outtype),
      callback: function($$v) {
        _vm.outtype = $$v
      },
      expression: "outtype"
    }
  }, _vm._l((_vm.outtypes), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "label": "JSON : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "28"
    },
    model: {
      value: (_vm.outdata),
      callback: function($$v) {
        _vm.outdata = $$v
      },
      expression: "outdata"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewDetailsVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var storage = {};

exports.default = {
  pageSize: 15,

  showMyDialog: false,
  mediaviewer: '',

  getRelated: function getRelated() {
    return {
      "Starren": [{ cd: "1", va: "1 Star" }, { cd: "2", va: "3 Star" }, { cd: "3", va: "3 Star" }, { cd: "4", va: "4 Star" }, { cd: "5", va: "5 Star" }],
      "status": [{ cd: "1", va: "Yes" }, { cd: "0", va: "No" }],
      "active": [{ cd: "1", va: "Active" }, { cd: "0", va: "Not Active" }]
    };
  },

  getValue: function getValue(name) {
    return storage[name];
  },

  setValue: function setValue(name, value) {
    storage[name] = value;
  },

  confirmed: "Confirmed",
  savedone: "Done",

  getText: function getText(textid, var1, var2, var3) {
    var txt;
    if (textid == 100) txt = "Zeker weten om {1} '{2}' te verwijderen ?";else if (textid == 101) txt = "Verwijder {1}";else if (textid == 102) txt = "De {1} met omschrijving {2} is verwijderd.";else if (textid == 110) txt = "Wijzig {1} {2}";else if (textid == 111) txt = "Toevoegen {1}";else if (textid == 120) txt = "Deze {1} is toevoegd";else if (textid == 121) txt = "Deze {1} is gewijzigd!";

    return txt.replace("{1}", var1).replace("{2}", var2).replace("{3}", var3);
  }
};

/***/ })

},[312]);


// WEBPACK FOOTER //
// static/js/app.6b7e079d901586cf00fb.js